const ComponentBase = require('../../base/ComponentBase');
const CommonUtil = require('../../utils/CommonUtil');
const GeometryUtil = require('../../utils/GeometryUtil');
const g2 = require('../../g2');

/**
 * @constructor
 * @classdesc 台风路径
 * @augments G.base.ComponentBase
 * @alias G.biz.TyphoonTrack
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {G.service.ITyphoonService} options.service  服务
 * @param {String} options.tfbh        默认显示的台风编号，选填，格式YYYYNN
 * @param {String} options.picSymbol.typhoonIcon    默认显示的台风图片，base64格式字符串，选填
 * @param {Object} options.interfaceMsg   组件默认传出接口消息对象定义，选填；下面更为详细介绍；
 * @param {Object} options.interfaceMsg.forecastPoint   组件默认传出预报点接口消息对象，选填；例如{'forecastPoint':{ 'name'  :'mousemoveForecastPoint','enable':1 }
 * @param {String} options.interfaceMsg.forecastPoint.name    台风预报消息接口名称
 * @param {Number} options.interfaceMsg.forecastPoint.enable  台风预报消息接口可用标志，0：不可用，1可用
 * @param {String} options.interfaceMsg.trackPoint.name    台风轨迹点消息接口名称
 * @param {Int} options.interfaceMsg.trackPoint.enable  台风轨迹点消息接口可用标志，0：不可用，1可用
 * @param {Object} options.layerOrder  组件内图层顺序对象，选填，下面更为详细介绍；
 * @param {Object} options.layerOrder.trackLine  ,台风路径线图层，例如{id: 'typhoon_line',name: '台风路径线图层', zIndex:101, }
 * @param {String} options.layerOrder.trackLine.id     台风路径线图层ID
 * @param {String} options.layerOrder.trackLine.name  台风路径线图层名称
 * @param {Int} options.layerOrder.trackLine.zIndex    台风路径线图层顺序
 * @param {Object} options.layerOrder.trackPoint   台风路径点图层顺序对象，属性同上，例如：{
 * @param {Object} options.typhoon   台风显示相关对象，选填，下面一一介绍
 * @param {Int} options.typhoon.lineSingleColorFlag  线型单色颜色标志，1：单线颜色；0：多线颜色，缺省0；
 * @param {Object} options.typhoon.lineColor  ts-gis颜色对象，例如{ a: 153, r: 255, g: 255, b: 255 }
 * @param {Int} options.typhoon.lineColor.a  透明率，值域[0-255]
 * @param {Int} options.typhoon.lineColor.r 红色值，值域[0-255]
 * @param {Int} options.typhoon.lineColor.g  绿色值，值域[0-255]
 * @param {Int} options.typhoon.lineColor.b  蓝色值，值域[0-255]
 * @param {Object} options.typhoon.nameTextSymbol  台风名称标注样式对象，属性如下：
 * @param {Int} options.typhoon.nameTextSymbol.fontSize  字体大小
 * @param {String} options.typhoon.nameTextSymbol.fontWeight  字体粗细，可选normal，bold，italics
 * @param {String} options.typhoon.nameTextSymbol.fontFamilyName  字体名称,例如：宋体
 * @param {Object} options.typhoon.nameTextSymbol.foreground  ts-gis颜色对象，例如{a: 255, r: 0, g: 0, b: 0}
 * @param {Object} options.typhoon.nameTextSymbol.borderColor  ts-gis颜色对象，例如{a: 255, r: 0, g: 0, b: 0}
 * @param {Int} options.typhoon.nameTextSymbol.offsetY  Y轴上偏移量，单位：像素。
 * @param {Int} options.typhoon.nameTextSymbol.borderThickness  边框厚度，单位：像素。
 * @param {Object} options.typhoon.focusPointSymbol  台风焦点样式对象
 * @param {String} options.typhoon.focusPointSymbol.fillColor  填充颜色值，十六进制表示方法，例如'#FFFFFF'
 * @param {Int} options.typhoon.focusPointSymbol.fillOpacity  填充透明率，值域[0,255]，缺省153
 * @param {String} options.typhoon.focusPointSymbol.borderColor  边框填充颜色值，十六进制表示方法，例如'#80808C'
 * @param {Int} options.typhoon.focusPointSymbol.opacity  边框透明率，值域[0,255]，缺省153
 * @param {Num} options.typhoon.focusPointSymbol.weight  边框宽度，单位：像素，缺省0.5
 * @param {Num} options.typhoon.focusPointSymbol.radius  填充半径，单位：像素，缺省12
 * @param {object[]} options.typhoonSpeeds  台风速度的等级数组对象，速度单位 米/秒【m/s】，每个数组元素的格式 [minSpeed，maxSpeed]；缺省值：[[0.1,10.7],[10.8,17.1], [17.2,24.4], [24.5,32.6], [32.7,41.4],[41.5,50.9], [51,120]],
 * @param {Array<String>} options.typhoonLevel   台风级别名称数组，依照上述速度划分的级别，缺省值：['常态气压'   ,'热带低压','热带风暴','强热带风暴','台风',   '强台风', '超强台风']
 * @param {Array<String>} options.typhoonPointColor  台风级别的颜色数组，缺省值：['#000000','#02FF02','#39C7CF', '#FBF9CC',  '#FFDE75','#FF8515','#FF5252']
 * @param {Object} options.forecast  台风预报路径的显示样式对象
 * @param {Object} options.forecast.lineStyle  台风预报路径线型样式对象
 * @param {Int} options.forecast.lineStyle.opacity  台风预报线透明度[0,255]，缺省153
 * @param {Int} options.forecast.lineStyle.width  台风预报线宽度，单位像素，缺省2
 * @param {Int} options.forecast.lineStyle.style  台风预报线样式，简单直线样式,Dash = 0, DashDot = 1, DashDotDot = 2, Dot = 3, Null = 4,Solid = 5，缺省初始化为2
 * @param {Objects} options.forecast.org  预报机构集合的对应样式对象,缺省已经包括中国、中国香港、中国台湾、南海所、广东、浙江、日本、美国、韩国、菲律宾、欧洲。
 * @param {Object} options.forecast.org.中国  中国，显示的样式对象 例如：{ rgb:'#FF0000' , display:1 }
 * @param {String} options.forecast.org.中国.rgb  显示颜色，RGB的16进制表示法，例如rgb:'#FF0000'
 * @param {Int} options.forecast.org.中国.display  显隐开关，1：显示，0：隐藏，不显示，缺省为1
 * @param {Object} options.forecast.org.中国台湾  中国台湾，属性详解同上，缺省为：{ rgb:'#FFFF00',display:1 }
 * @param {Object} options.forecast.org.中国香港  中国香港，属性详解同上，缺省为：{ rgb:'#FFA500',display:1 }
 * @param {Object} options.forecast.org.南海所  中国南海所，属性详解同上，缺省为：{ rgb:'#800080',display:1 }
 * @param {Object} options.forecast.org.广东  中国广东，属性详解同上，缺省为：{ rgb:'#4B0082',display:1 }
 * @param {Object} options.forecast.org.浙江  中国浙江，属性详解同上，缺省为：{ rgb:'#FFC0CB',display:1 }
 * @param {Object} options.forecast.org.日本  日本，属性详解同上，缺省为：{ rgb:'#00FF00',display:1 }
 * @param {Object} options.forecast.org.美国  美国，属性详解同上，缺省为：{ rgb:'#0000FF',display:1 }
 * @param {Object} options.forecast.org.菲律宾  菲律宾，属性详解同上，缺省为：{ rgb:'#22B14C',display:1 }
 * @param {Object} options.forecast.org.韩国  韩国，属性详解同上，缺省为：{ rgb:'#B97A57',display:1 }
 * @param {Object} options.forecast.org.欧洲  欧洲，属性详解同上，缺省为：{ rgb:'#B5E61D',display:1 }
 * @param {Object} options.forecast.org.null  预报机构没有预先设置时候，会给一个默认对象，属性详解同上，缺省为：{ rgb:'#000000',display:1}
 * @param {Object} options.popup  台风路径上真实轨迹点信息弹出框设置对象，可缺省。
 * @param {Int} options.popup.display  显隐标志，1：显示，0：隐藏，缺省为1
 * @param {Int[]} options.popup.offset  偏移坐标[x,y]，单位像素，缺省为[-50,10]
 * @param {String} options.popup.divStyle  信息框中div的样式字符串，缺省为'font-size:12px;color:#000 ;background: transparent; margin-top: 8px;margin-left: 10px; margin-right: 0px;'
 * @param {String} options.popup.liStyle   信息框中li的样式字符串，缺省为'height:20px;margin:2px;'
 * @param {Int} options.popup.pointPrecision  点坐标小数位的精度，缺省为3
 * @param {Object} options.popup.typhoonName  名称的显示设置对象，缺省为{ display:1,label:'台风编号：',unit:''}
 * @param {Int} options.popup.typhoonName.display  显隐标志，0：不显示，1：显示，缺省为1
 * @param {String} options.popup.typhoonName.label  标注名称，缺省为'台风编号：'
 * @param {String}options.popup.typhoonName.unit  显示单位，缺省为''
 * @param {Object} options.popup.passTime  过去时间的显示设置对象，属性同上，缺省为{ display:1,label:'过去时间：',unit:''}
 * @param {Object} options.popup.centerPoint  中心位置的显示设置对象，缺省为{ display:1,label:'中心位置：', x:'#lon#',y:'#lat#',format:'#lon#E,#lat#N',unit:''}
 * @param {Int} options.popup.centerPoint.display 显隐开关
 * @param {String} options.popup.centerPoint.x 经度代指
 * @param {String} options.popup.centerPoint.y 纬度代指
 * @param {String} options.popup.centerPoint.format 格式，缺省为'#lon#E,#lat#N'
 * @param {String} options.popup.centerPoint.unit 单位，缺省为''
 * @param {Object} options.popup.power最大风力显示设置对象
 * @param {Int} options.popup.power.display  显隐标志，0：不显示，1：显示，缺省为1
 * @param {String} options.popup.power.label 标注名称，缺省为'最大风力：'
 * @param {String} options.popup.power.unit   显示单位，缺省为'级'
 * @param {Object} options.popup.speed　最大风速显示设置对象，属性同上，缺省为{display:1,label:'最大风速：',unit:'米/秒'}
 * @param {Int} options.popup.speed.display  显隐标志，0：不显示，1：显示，缺省为1
 * @param {String} options.popup.speed.label  标注名称，缺省为'最大风速：'
 * @param {String} options.popup.speed.unit   显示单位，缺省为'米/秒'
 * @param {Object}options.popup.moveSpeed  移动速度显示设置对象，属性同上，缺省为{display:1, label:'移动速度：', unit:'公里/小时'}
 * @param {Object} options.popup.moveDir  移动方向显示设置对象，属性同上，缺省为{display:1,label:'移动方向：', unit:''}
 * @param {Object} options.popup.sevenRingRadius 　七级风圈半径显示设置对象，属性同上，缺省为{display:1,label:'七级风圈半径:',unit:'公里'}
 * @param {Object} options.popup.tenRingRadius 　十级风圈半径显示设置对象，属性同上，缺省为{display:1,label:'七级风圈半径:',unit:'公里'}
 * @param {Object} options.popup.twelveRingRadius 　十二级风圈半径显示设置对象，属性同上，缺省为{display:1,label:'七级风圈半径:',unit:'公里'}
 * @param {Object} options.popupForecast  台风路径上预测信息弹出框设置对象，可缺省。　
 * @param {Int} options.popupForecast.display  显隐标志，1：显示，0：隐藏，缺省为1
 * @param {Int[]} options.popupForecast.offset  偏移坐标[x,y]，单位像素，缺省为[-50,10]
 * @param {String} options.popupForecast.divStyle  信息框中div的样式字符串，缺省为'font-size:12px;color:#000 ;background: transparent; margin-top: 8px;margin-left: 10px; margin-right: 0px;'
 * @param {String} options.popupForecast.liStyle   信息框中li的样式字符串，缺省为'height:20px;margin:2px;'
 * @param {Object} options.popupForecast.org  预报机构的显示设置对象，缺省为{display:1,label:'预报机构：',unit:''}
 * @param {Int} options.popupForecast.org.display  显隐标志，0：不显示，1：显示，缺省为1
 * @param {String} options.popupForecast.org.label  标注名称，缺省为'预报机构：'
 * @param {String} options.popupForecast.org.unit   显示单位，缺省为''
 * @param {Object} options.popupForecast.arrivalTime  到达时间的显示设置对象，属性同上，缺省为{display:1,label:'到达时间：', unit:''}
 * @param {Object}options.popupForecast.centerPoint  预报点中心位置的显示设置对象，缺省为{ display:1,label:'中心位置：', x:'#lon#',y:'#lat#',format:'#lon#E,#lat#N',unit:''}
 * @param {int} options.popupForecast.centerPoint.display 显隐开关
 * @param {String} options.popupForecast.centerPoint.x 经度代指
 * @param {String} options.popupForecast.centerPoint.y 纬度代指
 * @param {String} options.popupForecast.centerPoint.format 格式，缺省为'#lon#E,#lat#N'
 * @param {String} options.popupForecast.centerPoint.unit 单位，缺省为''
 * @param {Object} options.popupForecast.power  最大风力的显示设置对象，缺省为{display:1,label:'预报机构：',unit:''}
 * @param {Int} options.popupForecast.power.display  显隐标志，0：不显示，1：显示，缺省为1
 * @param {String} options.popupForecast.power.label  标注名称，缺省为'最大风力：'
 * @param {String} options.popupForecast.power.unit   显示单位，缺省为''
 * @param {Object} options.popupForecast.speed　最大风速显示设置对象，属性同上，缺省为{display:1,label:'最大风速：',unit:'米/秒'}
 * @param {Object} options.popupForecast.moveSpeed  移动速度显示设置对象，属性同上，缺省为{display:1, label:'移动速度：', unit:'公里/小时'}
 * @param {Object} options.popupForecast.moveDir   移动方向显示设置对象，属性同上，缺省为{display:1,label:'移动方向：', unit:''}
 * @param {Object} options.popupForecast.centralPressure  中心点的显示设置对象，属性同上，缺省为{display:1,label:'中心气压：',unit:'百帕'}
 */
let component = ComponentBase.extend({
    options: {},
    initialize: function (options) {
        
        ComponentBase.prototype.initialize.call(this, options);
        if (this.enable == true) return;
        this.map = options.map;
        this.options = {};
        this.options.picSymbol = this._initPicSymbolOptions(options);
        this.options.dataSpatialReference = 4326;//g2.sfs.SpatialReference.EPSG4326
        this.options.dataSpatialReference = this._mergeOptions(this.options.dataSpatialReference, options.dataSpatialReference);
        this.options.spatialReference = this.map.spatialReference;
        this.options.spatialReference = this._mergeOptions(this.options.spatialReference, options.spatialReference);
        this.options.projection = 1;//球面
        this.options.projection = this._mergeOptions(this.options.projection, options.projection);
        this.service = options.service;//查询service
        this.options.typhoon = {};
        this.options.typhoon = this._initTyphoonOptions(options);
        this.options.forecast = this._initForecast(options)
        this.options.popup = this._initPopup(options);
        this.options.popupForecast = this._initPopupForecast(options);
        this.options.toolTipWare = new g2.widget.TooltipWare({map: this.map});
        this.options.layerOrder = this._initLayerOrder(options);
        this.options.tfbh = options.tfbh;
        this.enable = true;
        this._initInterfaceMsg(options);//初始化对外的接口消息参数
    },
    
    /**
     * 组件加载
     * @method
     * @memberOf G.biz.TyphoonTrack.prototype
     */
    load() {
        
        if (!this.isLoaded()) {
            this.tyhoonPlayFlag = 0;    //台风正在播放标志        
            if (this.options.tfbh != undefined) {
                this.loadOneTyphoon(this.options.tfbh);//加载指定编号的台风
            }
            //加载指当前活动的台风
            //this._loadCurrentTyphoon();
            this.tf = {};
            this.tf.paths = {}; //多台风路径数据
            
            this.tf.realLine = {};//多线段elements
            this.tf.realPoints = {}; //typhoon 多点elements
            this.tf.realLabels = {};//台风标注信息集合
            
            this.tf.forecastLines = {}; //预报路径 线段
            this.tf.forecastPoints = {};  //预报路径 点
            this.tf.forecastPolygons = {}; //预测面
            
            this._initLayers();
        }
        ComponentBase.prototype.load.call(this);
    },
    
    
    addListeners() {
        
        if (this.options.mapType != undefined) {
            this._addListeners_tsmap();
        } else {
            this._addListeners();        //监听事件初始化
        }
    },
    /**
     * 获取加载状态
     * @method
     * @memberOf G.biz.TyphoonTrack.prototype
     * @returns {Boolean} - 已加载返回true，否则返回false；
     */
    getIsLoaded() {
        return this.isLoaded;
    },
    
    removeListeners() {
        this.map.off('click', this._getMapClickListener, this);
        this.map.off('mousemove', this._getMapMouseMoveListener, this);
    },
    service: null,
    
    /**
     * 设置数据请求service
     * @method
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param service
     */
    setService(service) {
        this.service = service;
    },
    /**
     * 清理台风组件中所有绘制信息
     * @public
     * @method clearAll
     * @memberOf G.biz.TyphoonTrack.prototype
     *
     */
    clearAll: function () {
        this.tf.Layer_point.clear();
        this.tf.Layer_line.clear();
        this.tf.selectPoint.clear();
        this._forecastsClear(); //各国预报信息轨迹清空
        this._clearCircle(); //清空台风半径
        this.tf.typhoonIconLayer.clear();
        this.tf.Layer_label.clear();
        // window.clearInterval(this.tf.typhoonInterval);
        this._clearIntervals(this.tf.typhoonInterval)
        // window.clearInterval(this.tf._ds);
        this._clearIntervals(this.tf._ds)
        this.tyhoonPlayFlag = 0;
    },
    /**
     * 清理台风组件中所有台风信息
     * @public
     * @method removeAll
     * @memberOf G.biz.TyphoonTrack.prototype
     *
     */
    removeAll: function () {
        this.clearAll();
        this.tf.paths = null;
    },
    
    
    /**
     * 清理台风组件中一条台风编号的绘制信息
     * @public
     * @method clearOneTyphoon
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tfbh {String} 必填值，台风编号(id)，格式YYYYNN，例如201901，201822。
     */
    clearOneTyphoon: function (tfbh) {
        if (this.tf.realLine[tfbh] == undefined) return;
        for (var i = 0; i < this.tf.realLine[tfbh].length; i++) {
            this.tf.Layer_line.remove(this.tf.realLine[tfbh][i]);
        }
        for (var j = 0; j < this.tf.realPoints[tfbh].length; j++) {
            this.tf.Layer_point.remove(this.tf.realPoints[tfbh][j]);
        }
        this.tf.Layer_label.remove(this.tf.realLabels[tfbh]);
        
        this._forecastsClear(); //各国预报信息轨迹清空
        // this._clearCircle(); //清空台风风圈半径
        this._clearCircleByTfbh(tfbh); //清空台风风圈半径
        this.tf.typhoonIconLayer.clear();
        window.clearInterval(this.tf.typhoonInterval[tfbh]);
        window.clearInterval(this.tf._ds[tfbh]);
        this.tyhoonPlayFlag = 0;
    },
    /**
     * 清理台风组件中一条台风编号的所有信息
     * @public
     * @method removeOneTyphoon
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tfbh {String} 必填值，台风编号(id)，格式YYYYNN，例如201901，201822。
     */
    removeOneTyphoon: function (tfbh) {
        this.clearOneTyphoon(tfbh);
        delete this.tf.paths[tfbh];
    },
    /**
     * 加载一条台风编号
     * @public
     * @method loadOneTyphoon
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tfbh {String} 必填值，台风编号(id)，格式YYYYNN，例如201901，201822。
     * @param [visibleFlag] {Boolean} 默认true，加载后是否展示台风轨迹，默认展示。
     * @param [fit] {Boolean} 默认true，加载后是否定位台风轨迹，默认定位。
     */
    loadOneTyphoon: function (tfbh, visibleFlag, fit) {
        return new Promise((resolve, reject) => {
            this._showTyphoonTrack(tfbh, visibleFlag, fit).then(() => {
                resolve();
            });
        })
    },
    /**
     * 加载一条台风数据
     * @public
     * @method loadOneTyphoonData
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param data {Object} 台风数据。
     * @param data.tfbh {String} 台风编号。
     * @param data.features {Array} 台风数据轨迹信息。
     * @param [data.name] {String} 台风名称。
     * @param [data.ename] {String} 台风英文名称。
     * @param data {Object} 必填值，台风数据。
     * @param [visibleFlag] {Boolean} 默认true，加载后是否展示台风轨迹，默认展示。
     * @param [fit] {Boolean} 默认true，加载后是否定位台风轨迹，默认定位。
     */
    loadOneTyphoonData: function (data, visibleFlag, fit) {
        this._showTyphoonTrackData(data, visibleFlag, fit);
    },
    /**
     * 播放一条台风路径轨迹
     * @public
     * @method playOneTyphoon
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tfbh {String} 必填值，台风编号(id)，格式YYYYNN，例如201年山竹台风：201822。
     * @param [interval] {Integer} 播放速度控制（两点之间播放间隔），默认500，单位毫秒。
     * @param [showCircle] {Object} 风圈半径显示设置
     * @param [showCircle.show] {boolean} 风圈半径是否显示,默认显示
     * @param [showForecast] {Object} 预测线显示设置
     * @param [showForecast.show] {boolean} 预测线是否显示,默认显示
     * @param [showForecastPoly] {Object} 预测面是否显示设置
     * @param [showForecastPoly.show] {boolean} 预测面是否显示,默认显示
     * @param [showForecastPoly.type] {boolean} 预测类型，不填的话默认中国
     */
    playOneTyphoon: function (tfbh, interval, showCircle, showForecast, showForecastPoly) {
        var _interval = 500;
        if (interval) {
            _interval = interval;
        }
        if (!(this.tf.paths[tfbh])) {return;}
        ;
        if (this.tf.realLine[tfbh] == undefined) {
            console.debug("no data ", tfbh, " ...");
            return;
        }
        ;
        if (this.tyhoonPlayFlag == 1) {
            console.log("有正在播放。", tfbh, "请等待...");
            return;
        }
        this.tyhoonPlayFlag = 1;
        
        this.clearOneTyphoon(tfbh);
        this._createTyphoonLabel(tfbh);
        var thisObj = this;
        //清除台风图标
        this.tf.typhoonIconLayer.clear();
        window.clearInterval(this.tf.typhoonInterval[tfbh]);
        window.clearInterval(this.tf._ds[tfbh]);
        var index = 0;
        var length = this.tf.realPoints[tfbh].length;
        var features = this.tf.realPoints[tfbh];
        if (!features || features.length < 1) {
            this.tyhoonPlayFlag = 0;
            return;
        }
        
        var ds = setInterval(function () {
            //台风动图
            thisObj.tf.typhoonIconLayer.clear();
            var nowEle = thisObj.tf.realPoints[tfbh][index + 1];
            thisObj._addTyphoonIconById(tfbh, nowEle, _interval);
            
            var _feature = features[index + 1]
            var _typhoonId = _feature._tfbh;
            var _time = _feature._data.properties.time.replace("T", " ");
            if (!(showCircle && showCircle.show == false)) {
                thisObj.showTyphoonCircle(_typhoonId, _time);
            }
            if (!(showForecast && showForecast.show == false)) {
                thisObj.showTyphoonForecast(_typhoonId, _time);
            }
            //台风路径
            thisObj.tf.Layer_line.add(thisObj.tf.realLine[tfbh][index]);
            thisObj.tf.Layer_point.add(features[index]);
            index++;
            thisObj.fire('typhoonMove', features[index]);
            // 播放完成 停止
            if (index >= length - 1) {
                thisObj.tf.Layer_point.add(features[index]);
                thisObj.tf.typhoonIconLayer.clear();
                window.clearInterval(thisObj.tf.typhoonInterval[tfbh]);
                var nowEle = thisObj.tf.realPoints[tfbh][index];
                thisObj._addTyphoonIconById(tfbh, nowEle, _interval);
                window.clearInterval(ds);
                ds = null;
                if (!(showForecastPoly && showForecastPoly.show == false)) {
                    thisObj._getForecastCircleTan(nowEle, showForecastPoly.type);
                }
                thisObj.fire('typhoonMoveEnd');
                // if (index > length - 1) {
                //
                // }
               
            }
        }, _interval);
        this.tf._ds[tfbh] = ds;
    },
    /**
     *显隐预报结果
     * @public
     * @method showForecasts
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param region {String} 必填值，预报机构名称
     * @param visibleFlag {Int} 必填值，显隐标志 1：显示，0：隐藏；
     */
    showForecasts: function (region, visibleFlag) {
        //if (this.tf.forecastLines[region] == undefined) return;
        this.options.forecast.org[region].display = visibleFlag;
        for (var key in this.tf.Layer_forecast) {
            if (this.tf.forecastLines[key]) {
                this.tf.Layer_forecast[key].showElement(this.tf.forecastLines[key][region], visibleFlag);
            }
            if (this.tf.forecastPoints[key]) {
                if (this.tf.forecastPoints[key][region]) {
                    for (var i = 0; i < this.tf.forecastPoints[key][region].length; i++) {
                        var ele = this.tf.forecastPoints[key][region][i];
                        this.tf.Layer_forecast.showElement(ele, visibleFlag);
                    }
                }
                
            }
        }
    },
    
    /**
     *选中台风轨迹的节点，触发点击事件
     * @public
     * @method selectTyphoonTrackPoint
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tyhoonId {String} 必填值，台风编号 'YYYYNN'
     * @param nodeTimeStr {String} 必填值，时间字符'yyyy-mm-dd HH:MM:SS'；
     */
    selectTyphoonTrackPoint: function (tyhoonId, nodeTimeStr) {
        if (this.tf.realPoints[tyhoonId] == undefined) return;
        var eles = this.tf.realPoints[tyhoonId];
        for (var i = 0; i < eles.length; i++) {
            var timeStr = eles[i]._data.properties.time.replace("T", " ");
            if (timeStr == nodeTimeStr) {
                this._showRoutePointPopup(eles[i]);
                return;
            }
        }
    },
    /**
     * 获取台风风圈信息
     * @public
     * @method getTyphoonCircleInfo
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tyhoonId {String} 必填值，台风编号 'YYYYNN'
     * @param nodeTimeStr {String} 必填值，时间字符'yyyy-mm-dd HH:MM:SS'；
     */
    getTyphoonCircleInfo: function (tyhoonId, nodeTimeStr) {
        if (this.tf.realPoints[tyhoonId] == undefined) return;
        var result = {};
        var eles = this.tf.realPoints[tyhoonId];
        for (var i = 0; i < eles.length; i++) {
            var timeStr = eles[i]._data.properties.time.replace("T", " ");
            if (timeStr == nodeTimeStr) {
                result = this._getTyphoonCircleInfo(eles[i]);
                break;
            }
        }
        return result;
    },
    
    /**
     *选中台风轨迹的节点，触发点击事件
     * @public
     * @method showTyphoonCircle
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tyhoonId {String} 必填值，台风编号 'YYYYNN'
     * @param nodeTimeStr {String} 必填值，时间字符'yyyy-mm-dd HH:MM:SS'；
     */
    showTyphoonCircle: function (tyhoonId, nodeTimeStr) {
        if (this.tf.realPoints[tyhoonId] == undefined) return;
        var eles = this.tf.realPoints[tyhoonId];
        
        for (var i = 0; i < eles.length; i++) {
            //判定是(i-1)否为最后一个带风圈的点位，若是，则保持不清除
            var isLast = true;
            for (let index = i; index < eles.length; index++) {
                const afterEle = eles[index];
                
                var _radius_7 = afterEle._data.properties.radius7 ? afterEle._data.properties.radius7 : 0;
                var _radius7_quad = afterEle._data.properties.radius7_quad;
                var _radius7_quad_val = 0;
                for (var key in _radius7_quad) {
                    const val = _radius7_quad[key];
                    if (val) {
                        _radius7_quad_val += val
                    }
                }
                var _radiusSum = _radius7_quad_val + _radius_7
                if (_radiusSum > 0) {
                    isLast = false;
                    break;
                }
            }
            var timeStr = eles[i]._data.properties.time.replace("T", " ");
            if (timeStr == nodeTimeStr) {
                if (isLast == false) {
                    this._showTyphoonCircle(eles[i]);
                    return;
                }
            }
        }
    },
    /**
     *选中台风轨迹的节点，触发点击事件
     * @public
     * @method showTyphoonForecast
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tyhoonId {String} 必填值，台风编号 'YYYYNN'
     * @param nodeTimeStr {String} 必填值，时间字符'yyyy-mm-dd HH:MM:SS'；
     */
    showTyphoonForecast: function (tyhoonId, nodeTimeStr) {
        if (this.tf.realPoints[tyhoonId] == undefined) return;
        var eles = this.tf.realPoints[tyhoonId];
        for (var i = 0; i < eles.length; i++) {
            var timeStr = eles[i]._data.properties.time.replace("T", " ");
            if (timeStr == nodeTimeStr) {
                this._showTyphoonForecast(eles[i]);
                return;
            }
        }
    },
    // /***
    //  * 对外接口方法：获取指定年份的所有台风简要信息
    //  * @year 台风所在年，格式 'YYYY'
    //  * @returns  {'status':'','data':''}；'status':1，成功，'data'返回数据；'status':-1，失败，'data'返回错误信息；
    //  */
    // /**
    //  *获取指定年份的所有台风简要信息
    //  * @public
    //  * @function getTyphoonsByYear
    //  * @param year {Int} 必填值，台风所在年，格式 YYYY
    //  * @returns {Object}返回结果对象 {'status':'','data':''}；'status':1，成功，'data'返回数据对象；'status':-1，失败，'data'返回错误信息
    //  * 例如 {'status':1,'data':[{"content":"灿都","ename":"Chanthu","end":"2016-08-14T02:00:00","id":201607,"is_current":1,"start":"2016-08-14T02:00:00"}]}
    //  */
    // getTyphoonsByYear: function (year) {
    //     var url = this.options.simplyurl + year + ".json";
    //     var returnObj = { 'status': -1, "data": '' };
    //     var resultData;
    //     this.service.getTyphoonsByYear({
    //         year:year
    //     }).then(function(data){
    //         resultData = data;
    //     });
    //     if (!!resultData) {
    //         returnObj.status = 1;
    //         returnObj.data = resultData;
    //     }else{
    //         returnObj.status = -1;
    //         returnObj.data = 'no data ! Please check data.....';
    //     }
    //     return returnObj
    // },
    
    // /***
    //  * 对外接口方法：获取指定台风编号的台风明细信息
    //  * @tfbh 台风编号【年+数字编号】，格式年＋ 'YYYYXX'
    //  * @retun  {'status':'','data':''}；'status':1，成功，'data'返回数据；'status':-1，失败，'data'返回错误信息；
    
    //  */
    // /**
    //  *获取指定台风编号的台风明细信息
    //  * @public
    //  * @function getTyphoonDetail
    //  * @param year {Int} 必填值，台风所在年，格式 YYYY
    //  * @returns {Object}返回结果对象 {'status':'','data':''}；'status':1，成功，'data'返回数据对象；'status':-1，失败，'data'返回错误信息
    //  */
    // getTyphoonDetail: function (tfbh) {
    //     var url = this.options.detailurl + tfbh + ".json";
    //     var returnObj = { 'status': -1, "data": '' };
    //     var resultData = this.service.getTyphoonInfo(url);
    //     if (!!resultData) {
    //         returnObj.status = 1;
    //         returnObj.data = resultData;
    //     }else{
    //         returnObj.status = -1;
    //         returnObj.data = 'no data ! Please check data.....';
    //     }        
    //     // this._ajaxModel(
    //     //     url,
    //     //     function (resultData) {
    //     //         returnObj.status = 1;
    //     //         returnObj.data = resultData[0]
    //     //     },
    //     //     function (errData) {
    //     //         returnObj.status = -1;
    //     //         if ((errData.status == 404) && (errData.statusText = "Not Found")) {
    //     //             returnObj.data = tfbh + ' no data ! Please check data.....';
    //     //         } else {
    //     //             returnObj.data = errData.statusText;
    //     //         }
    //     //     }
    //     // );
    //     return returnObj
    // },
    
    
    /**
     *启用/禁用 对外接口消息，目前对外支持消息有两种，
     * 'forecastPoint'：鼠标移动获取台风预测点信息事件，'trackPoint'：鼠标移动获取台风真实轨迹点事件
     * @public
     * @function openInterfaceMsg
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param msgName {String} 必填值，对外接收消息的名称
     * @param enable {Int} 必填值，启用标志：1，启用；0，禁用。
     */
    openInterfaceMsg: function (msgName, enable) {
        for (let index = 0; index < this.options.interfaceMsg[msgName].length; index++) {
            this.options.interfaceMsg[msgName][index].enable = enable;
            
        }
        this._updateEventsArray(this.options.interfaceMsg.trackPoint, this.options.interfaceMsg.forecastPoint);
    },
    /**
     *启用/禁用 真实轨迹点弹出框，
     * @public
     * @function openTrackPopup
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param display {Int} 必填值，启用标志：1，启用；0，禁用。
     */
    openTrackPopup: function (display) {
        this.options.popup.display = display;
    },
    /**
     *启用/禁用 预测轨迹点弹出框，
     * @public
     * @function openForecastPopup
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param display {Int} 必填值，启用标志：1，启用；0，禁用。
     */
    openForecastPopup: function (display) {
        this.options.popupForecast.display = display;
    },
    /**
     * 获取组件内所有加载的台风编号，
     * @public
     * @function getLoadedTyphoons
     * @memberOf G.biz.TyphoonTrack.prototype
     * @returns  {Object}；'status':1，成功，'data'返回数据；'status':-1，失败，'data'返回错误信息；
     */
    //todo 对外接口方法：获取组件内所有加载的台风编号
    getLoadedTyphoons: function () {
        
        var result = {
            'status': -1,
            'data': 'typhoon web component no init,no typhoon data...'
        };
        if (this.tf == undefined) {
            return result;
        }
        result = {
            'status': -1,
            'data': 'typhoon web component init,no typhoon data...'
        };
        if (this.tf.paths == undefined) {
            return result;
        }
        result = {
            'status': 1,
            'data': this.tf.paths
        };
        var allLoadTyphoons = [];
        var thisObj = this;
        
        for (const key in thisObj.tf.paths) {
            if (thisObj.tf.paths.hasOwnProperty(key)) {
                const element = thisObj.tf.paths[key];
                allLoadTyphoons.push(element);
            }
        }
        result.data = allLoadTyphoons;
        return result;
    },
    /**
     * 根据台风编号获取台风四至
     * @public
     * @function getExtentById
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tfbh {String} 必填值，台风编号(id)，格式YYYYNN，例如2018年山竹台风：201822。
     *
     */
    getExtentById: function (tfbh) {
        return new Promise(async (resolve, reject) => {
            var extent = null;
            if (this.tf.paths[tfbh] && this.tf.paths[tfbh].features) {
                var envelope = this._getBoundRect(this.tf.paths[tfbh].features);
                extent = [envelope.minx, envelope.miny, envelope.maxx, envelope.maxy];
                resolve(extent);
            } else {
                this._queryExtentById(tfbh).then(res => {
                    extent = res;
                    resolve(extent);
                });
            }
        })
        
    },
    /**
     * 加载一条台风编号
     * @public
     * @method loadOneTyphoon
     * @memberOf G.biz.TyphoonTrack.prototype
     * @param tfbh {String} 必填值，台风编号(id)，格式YYYYNN，例如201901，201822。
     * @param [visibleFlag] {Boolean} 默认true，加载后是否展示台风轨迹，默认展示。
     * @param [fit] {Boolean} 默认true，加载后是否定位台风轨迹，默认定位。
     */
    getTyphoonCircleTan: function (tfbh, visibleFlag, fit) {
        return new Promise((resolve, reject) => {
            this._getTyphoonCircleTan(tfbh, visibleFlag, fit).then(() => {
                resolve();
            });
        })
    },
    _queryExtentById: async function (tfbh) {
        var data = await this.service.getTyphoonInfo({typhoonid: tfbh})
        var resultData = data;
        var oneData = resultData[0];
        var features = oneData.features;
        var envelope = this._getBoundRect(features);
        var extent = [envelope.minx, envelope.miny, envelope.maxx, envelope.maxy];
        return extent;
    },
    /**
     * 卸载台风组件
     * @public
     * @function unload
     * @memberOf G.biz.TyphoonTrack.prototype
     *
     */
    unload: function () {
        if (this.enable == false) return;
        //监听事件解除
        // this.off(this.options.interfaceMsg.forecastPoint.name);
        // this.off(this.options.interfaceMsg.trackPoint.name);
        
        var events = this.trackClickEvent.concat(this.trackMousemoveEvent).concat(this.forecastClickEvent).concat(this.forecastMousemoveEvent);
        for (let index = 0; index < events.length; index++) {
            const _event = events[index];
            this.off(_event);
        }
        //清除效果
        this.clearAll();
        //清除图层
        this.map.removeLayer(this.tf.typhoonIconLayer);//图片元素图层
        this.map.removeLayer(this.tf.Layer_line); //台风线段图层
        this.map.removeLayer(this.tf.Layer_point); //台风路径点图层
        this.map.removeLayer(this.tf.selectPoint); //台风路径点 Focus图层
        this.map.removeLayer(this.tf.Layer_label); //台风标注图层 trackLabel
        
        for (var key in this.tf.Layer_Circle) {
            this.map.removeLayer(this.tf.Layer_Circle[key]); //风圈
        }
        for (var key in this.tf.Layer_forecast) {
            this.map.removeLayer(this.tf.Layer_forecast[key]);//预报图层
        }
        
        //变量置空
        this.tf.paths = {}; //多台风路径数据
        this.tf.realLine = {};//多线段elements
        this.tf.realPoints = {}; //typhoon 多点elements
        this.tf.realLabels = {};//台风标注信息集合
        this.tf.forecastLines = {}; //预报路径 线
        this.tf.forecastPoints = {};  //预报路径 点
        this.tf.forecastPolygons = {};  //预报路径 点
        this.tf = undefined;
        ComponentBase.prototype.unload.call(this);
    },
    /**
     * 销毁台风组件
     * @public
     * @function destroy
     * @memberOf G.biz.TyphoonTrack.prototype
     */
    destroy: function () {
        this.unload();
        this.options = undefined;
        this.enable = false;
        ComponentBase.prototype.destroy.call(this);
    },
    
    _clearIntervals(kvObj){
        for (var key in kvObj) {
            window.clearInterval(kvObj[key]);
        }
    },
    //参数合并
    _mergeOptions: function (dest) {
        var i, j, len, src;
        for (var j = 1, len = arguments.length; j < len; j++) {
            src = arguments[j];
            for (i in src) {
                dest[i] = src[i]
            }
        }
        return dest
    },
    //合并变量字符串类型参数
    _mergeStr: function (dest, src) {
        if (src != undefined) {
            dest = src;
        }
        return dest
    },
    //初始化图片集合参数
    _initPicSymbolOptions: function (options) {
        this.options.picSymbol = {
            typhoonIcon: 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAggSURBVGhDvZl7bFRVEMZREJAiogI+ACuIihhEQCIkCooGSEQSjMFIML7ABGs0xqhgokWDgMQYDBogqNWIEqr4DwLiIzw1IWKssWDaNLSlLX3Sd7t9wK6/7zqnuWy33bt06U1O9t7zmPlmzsycmbN9+iT5iUQifYuLi69JMtmLQ66kpGTZ6dOni/ldUVlZecXF4ZIkqmVlZQsAmo9214bD4QFJIttzMmz5JdFUSktLUwD7He2fY8eODfKPM/8ytJ6KIJOLiooeY+5zCLeM99n0T+V3VHZ2dv+eI+uCAgxHwHCsf7igoGAMYM9Ju/7+/Pz8ofRvAdg5WsTf6A/7GzQ1foQ2M6ngAXwTjNrLy8sHO8IwmVZVVRUB8DN+Zszby/w2AxPRnJqamlb6M1g/59SpU+NYO5z+IdoJtczMzL7Ru9RjAWCSA9PPHSHe5wJEgF/zCTELxws5sIxLo9udBvfv399PJsL3GtZtZWw9QsxFiMt7DDCaAMQXQzzi+tn625uamrSl2c7G0ezsuro6zww0F1BlFRUVt2oN6+fwfaKxsTGCUOeZinYhFApFAP4rNB5ImgND7CBM//BptAggZ913YWHh2IaGhg4wjP2sMcDfTAtF27S+ZdP8nhUdmZ39hiVUtLklvAto4Orm5uYIW75EixHgGxGGybc+U8l3wOjPUT/fnzkz8YPWbgDqbQS9Qf7BTvXTIcTuDYTXSOa+UF9fH4JOFd+zEgZsW7tZW6h3EQd0M0QFepj6IPyR23JpS87F79FoMzDgIfkAbbm0SXtIESkWMGislDkxvjph4CzKg8BBE2CltMd3tgmhGFzv02Q17//G0rCbI3tXw94jZ86cicispBTGv4fuQv+xL4Hor2b+1ljnQ0xhNBFCjbR3bcvbjfkGM5W07gDGsuV4fRIGfl+lp6df6vOhk6zbFUjjmMEwaQPpF9nBou2SVp43IdrigQgybjQ7HNkU0Ur/0w4ofdkI82Vc4DBcYmFsGrY7UcS1tfQ/iiC3JVHLTdDMEH1HE4CeCcFnjYDKbJjThAPf1y1wiGyS0zE5FWIzpDUjNJ/vxUG0GHQOdl0jRQD2Y3i0CLQv5j9r5jhGDt5t5sjCAwIt0+D9XhExR1woGwsKKIF5YU7MO8lnrmdNi1snZ0XDd5jG19HvaT/mw+BfAg3QawF+jyOCqSxNAMh5J2CQdWaKIyyquPWHHEiwFHRZXDD4Z21trSclzCY4h0Hru6urqxMGEwSwzWlUPgKw0ZjCWfUpz2EXbjFtj6ZvXYemAfaF+wDcHklL38MuejgTCQpA5gTzI6zfx3t50HXM225nw4vyI9GBxm5fGHylAzSTc/Py8rxTSvHZvPkt+/akDtpgEmKnrnLEdWSztjDIeu0wkeo645tna8qg4cVvpRf0TfVo87IWsC/pHcDTLdh7yRJjG4OGOVv3TrSzwLS/Yn8Q4Mz52wCmmX23K731KaGv9y67QUNZetepxMI2i9UTVI0EZOYdzXLeWB4ODcXlIMDbVCCYwtqkCGfXnegq3ADUK/15P2kO6Hkvu1AchKEOIdZtjiaOMCODatrs+HXRgNY2fdOWxlKEgH1C22uaf1MBXVKyUFFkeVQo6lJjzFd5NkmllPIYs0N/ghVE2yFT3lPCAP8NMUFjBpM1wQ0ysda025KbmzuA96Ig2tYcS/arlR/TWoOss1RBSZIXNZRnYxaTFPZcVIkJHC0dIVT9ZCax1G0p/QL8alBtBwEZPUc+BNiNrh/A07OyslKsOuo4ZDoBVx5g2zHBgP9gmlMoKpGDXgigIGtUf6oAdpEKLGnCoNOZ98Mxtew60eoBOaW+Ke+V8JcGYdrTOSrvoJHqc9htZtfNmNjObkErJrJY1YhXqOpwUA0Ynf/2FKTP9j3HhH6z+Lnqnj5nphWMeQVJtw/bdL9qNRdNzFRW2RVCEO+PO0eOpwTfp9nfnTmYQB9Y2GvCZIMVuwB/w+zpkDuWCYPjsa+DMAonQfMNCqc+535PIN21BGPzzTxC/hOxk7aRaLK/E4nXyDGsEl9J+BlqhIYrsVIteSFmYs42T0mZhTrtzEyyyCstiijkjTNNt7jcI6Z5oMUZADmvmFTp7yuHVOTqOK5hni5vXNEb1xyihPvNTO5D9Sti0VQEzNShJkGUTihnoe+XeOaso3MFTVmZF/b0AHoiJlHSxb1GTMACgtZqEewJaHXsCP11LrfwJWJZJsQWO8Y9UxFfl/XFBY5207VNMFyl49gtgPly+o7rlHLHvOUGnrbUz6+ugA8jeJpdR2TL/q1orVKObgBX25ngmQJzB6rIYLxFodbmeJdDgR8VtTCvs1vQObrCcos51oco+CPE+4DRxfpO2mq+/891efi+ES1VWDjTbtQ5rVnm2CZhaMfNdveY5r1Q26MHQgtp7aatTfFuOAE7hZbrbNiK4l3utoixQT4HbpPtEkFGmda9RCkpj7RsTrq7tbVVWqukHaXvR3530A7rAKLVuRBm5pVDlT3FgdA1sNZKAWi9nvnjZRZybLukXJQUwNFEdP+A9uRcGbQcHTgqkyxUnVMxQdNfGHf71wLwZUUF7FZ/beiSJkXjvH9qWl5/UQDHIqptVwXtQPjnYEopjD2IkC1WIJzg14u/ehRODfCOXgPcFSPZNYD2+ZxQRWqq/xZUqaeduF/3GmD+UhusaAG4x2lrZdc0XbSHZTICjVaf1C5EgwL8IDQcZmxBrwF2jDCJMSpkYf4I2tU93zxzrk7/O/rW6B+zTBevex10ogxVtqH9uxJdFz3/P/gcX4PsbnO8AAAAAElFTkSuQmCC',
        };
        this.options.picSymbol = this._mergeOptions(this.options.picSymbol, options.picSymbol);
        return this.options.picSymbol;
    },
    //创建指定参数的图层
    _createLayer: function (layerOrder, oMap) {
        var layerObj = null;
        layerObj = new g2.carto.ElementLayer({
            id: layerOrder.id,
            name: layerOrder.name,
            zIndex: layerOrder.zIndex,
            map: oMap
        });
        oMap.addLayer(layerObj);
        return layerObj;
    },
    //初始化台风相关参数
    _initTyphoonOptions: function (options) {
        this.options.typhoon.lineColor = {a: 153, r: 255, g: 255, b: 255}; //线型颜色样式
        this.options.typhoon.lineSingleColorFlag = 0; //0:线型多色标志，缺省；1:线型单色颜色标志
        this.options.typhoon.lineColor = this._mergeOptions(this.options.typhoon.lineColor, options.typhoon.lineColor);
        this.options.typhoon.lineSingleColorFlag = this._mergeOptions(this.options.typhoon.lineSingleColorFlag, options.typhoon.lineSingleColorFlag);
        this.options.typhoon.nameTextSymbol = {
            text: "台风名称文本样式",
            fontSize: 14,
            fontWeight: "normal",
            fontFamilyName: "宋体",
            foreground: {a: 255, r: 0, g: 0, b: 0},
            borderColor: {a: 255, r: 0, g: 0, b: 0},
            offsetY: 20,
            borderThickness: 1
        };
        this.options.typhoon.nameTextSymbol = this._mergeOptions(this.options.typhoon.nameTextSymbol, options.typhoon.nameTextSymbol);
        this.options.typhoon.focusPointSymbol = {
            fillColor: '#FFFFFF',//cols
            borderColor: '#80808C',//#80808C
            weight: 0.5,
            opacity: 153,
            fillOpacity: 150,//255,
            radius: 12
        }
        this.options.typhoon.focusPointSymbol = this._mergeOptions(this.options.typhoon.focusPointSymbol, options.typhoon.focusPointSymbol);
        
        this.options.typhoon.typhoonSpeeds = [[0.1, 10.7], [10.8, 17.1], [17.2, 24.4], [24.5, 32.6], [32.7, 41.4], [41.5, 50.9], [51, 120]];
        this.options.typhoon.typhoonLevel = ['常态气压', '热带低压', '热带风暴', '强热带风暴', '台风', '强台风', '超强台风'];
        this.options.typhoon.typhoonPointColor = ['#000000', '#02FF02', '#39C7CF', '#FBF9CC', '#FFDE75', '#FF8515', '#FF5252'];
        this.options.typhoon.typhoonSpeeds = this._mergeOptions(this.options.typhoon.typhoonSpeeds, options.typhoon.typhoonSpeeds);
        this.options.typhoon.typhoonLevel = this._mergeOptions(this.options.typhoon.typhoonLevel, options.typhoon.typhoonLevel);
        this.options.typhoon.typhoonPointColor = this._mergeOptions(this.options.typhoon.typhoonPointColor, options.typhoon.typhoonPointColor);
        return this.options.typhoon;
    },
    //初始化预测机构相关参数
    _initForecast: function (options) {
        this.options.forecast = {
            lineStyle: {
                width: 2,//默认初始化为2
                style: 2,//简单直线样式,Dash = 0, DashDot = 1, DashDotDot = 2, Dot = 3, Null = 4,Solid = 5，默认初始化为2
            },
            polyStyle: {
                style: 3,//简单直线样式,Dash = 0, DashDot = 1, DashDotDot = 2, Dot = 3, Null = 4,Solid = 5，默认初始化为2
            },
            org: {
                "中国": {
                    rgb: '#FF0000',
                    display: 1,
                },
                "CN": {
                    rgb: '#FF0000',
                    display: 1,
                },
                "中国香港": {
                    rgb: '#FFA500',
                    display: 1,
                },
                "HK": {
                    rgb: '#FFA500',
                    display: 1,
                },
                "中国台湾": {
                    rgb: '#FFFF00',
                    display: 1,
                },
                "TW": {
                    rgb: '#FFFF00',
                    display: 1,
                },
                "日本": {
                    rgb: '#00FF00',
                    display: 1,
                },
                "JP": {
                    rgb: '#00FF00',
                    display: 1,
                },
                "美国": {
                    rgb: '#0000FF',
                    display: 1,
                },
                "US": {
                    rgb: '#0000FF',
                    display: 1,
                },
                "韩国": {
                    rgb: '#B97A57',
                    display: 1,
                },
                "KR": {
                    rgb: '#B97A57',
                    display: 1,
                },
                "南海": {
                    rgb: '#800080',
                    display: 1,
                },
                "NH": {
                    rgb: '#800080',
                    display: 1,
                },
                "浙江": {
                    rgb: '#FFC0CB',
                    display: 1,
                },
                "ZJ": {
                    rgb: '#FFC0CB',
                    display: 1,
                },
                "菲律宾": {
                    rgb: '#22B14C',
                    display: 1,
                },
                "广东": {
                    rgb: '#4B0082',
                    display: 1,
                },
                "欧洲": {
                    rgb: '#B5E61D',
                    display: 1,
                },
                "null": {
                    rgb: '#000000',
                    display: 1,
                }
            }
        };
        this.options.forecast.lineStyle = this._mergeOptions(this.options.forecast.lineStyle, options.forecast.lineStyle);
        this.options.forecast.org = this._mergeOptions(this.options.forecast.org, options.forecast.org);
        return this.options.forecast;
    },
    //初始化地图弹出框的台风实际点信息
    _initPopup: function (options) {
        this.options.popup = {//弹出框参数
            display: 1,
            offset: [-200, 100],//偏移坐标x,y [-200,100]
            //div style
            divStyle: 'font-size:12px;color:#000 ;background: transparent; margin-top: 8px;margin-left: 10px; margin-right: 0px;',
            liStyle: 'height:20px;margin:2px;',
            pointEPSG: 4326,//point需要转换成的目标坐标系
            pointPrecision: 3,//point需要转换成的目标坐标小数位的精度
            //isShowRing : 0,//是否显示风圈.0展示。1不展示
            typhoonName: {
                display: 1,
                label: '台风编号：',
                unit: ''
            },
            passTime: {
                display: 1,
                label: '过去时间：',
                unit: ''
            },
            centerPoint: {
                display: 1,
                label: '中心位置：',
                x: '#lon#',
                y: '#lat#',
                format: '#lon#E,#lat#N',
                unit: ''
            },
            centerPressure: {
                display: 1,
                label: '中心气压：',
                unit: '百帕'
            },
            power: {
                display: 1,
                label: '最大风力：',
                unit: '级'
            },
            speed: {
                display: 1,
                label: '最大风速：',
                unit: '米/秒'
            },
            moveSpeed: {
                display: 1,
                label: '移动速度：',
                unit: '公里/小时'
            },
            moveDir: {
                display: 1,
                label: '移动方向：',
                unit: ''
            },
            sevenRingRadius: {
                display: 1,
                label: '七级风圈半径:',
                unit: '公里'
            },
            tenRingRadius: {
                display: 1,
                label: '十级风圈半径:',
                unit: '公里'
            },
            twelveRingRadius: {
                display: 1,
                label: '十二级风圈半径:',
                unit: '公里'
            },
            
        };
        this.options.popup = this._mergeOptions(this.options.popup, options.popup);
        return this.options.popup;
    },
    //初始化地图弹出框台风预测点信息
    _initPopupForecast: function (options) {
        this.options.popupForecast = {
            display: 1,
            offset: [-200, 100],//偏移坐标x,y
            //div style
            divStyle: 'font-size:12px;color:#000 ;background: transparent; margin-top: 8px;margin-left: 10px; margin-right: 0px;',
            liStyle: 'height:20px;margin:2px;',
            pointEPSG: 4326,//point需要转换成的目标坐标系
            org: {
                display: 1,
                label: '预报机构：',
                unit: ''
            },
            arrivalTime: {
                display: 1,
                label: '到达时间：',
                unit: ''
            },
            centerPoint: {
                display: 1,
                label: '中心位置：',
                x: '#lon#',
                y: '#lat#',
                format: '#lon#,#lat#',
                unit: ''
            },
            power: {
                display: 1,
                label: '最大风力：',
                unit: '级'
            },
            speed: {
                display: 1,
                label: '最大风速：',
                unit: '米/秒'
            },
            moveSpeed: {
                display: 1,
                label: '移动速度：',
                unit: '公里/小时'
            },
            moveDir: {
                display: 1,
                label: '移动方向：',
                unit: ''
            },
            centralPressure: {
                display: 1,
                label: '中心气压：',
                unit: '百帕'
            },
            pointPrecision: 3 //point需要转换成的目标坐标小数位的精度
        };
        this.options.popupForecast = this._mergeOptions(this.options.popupForecast, options.popupForecast);
        return this.options.popupForecast
    },
    // 初始化图层集合顺序参数
    _initLayerOrder: function (options) {
        this.options.layerOrder = {
            trackLine: {
                id: 'typhoon_line',
                name: '台风路径线图层',
                zIndex: 101,
            },
            trackPoint: {
                id: 'typhoon_point',
                name: '台风路径点图层',
                zIndex: 102,
            },
            focusPoint: {
                id: 'typhoon_focus_point',
                name: '台风路径点焦点图层',
                zIndex: 101,
            },
            trackLabel: {
                id: 'typhoon_label',
                name: '台风路径文本',
                zIndex: 100,
            },
            typhoonRing: {
                id: 'typhoon_ring',
                name: '台风路径风圈',
                zIndex: 100,
            },
            typhoonForecast: {
                id: 'typhoon_forecast',
                name: '预报图层',
                zIndex: 101,
            },
            typhoonIcon: {
                id: "typhoon_icon_Layer",
                name: '台风风眼图标',
                zIndex: 100,
            }
        };
        this.options.layerOrder = this._mergeOptions(this.options.layerOrder, options.layerOrder);
        return this.options.layerOrder;
    },
    //初始化图层集合
    _initLayers: function () {
        //创建元素图层this.picSymbol.typhoonIcon
        this.tf.typhoonIconLayer = null;
        this.tf.typhoonIconLayer = this._createLayer(this.options.layerOrder.typhoonIcon, this.map);
        this.tf.typhoonInterval = {};
        this.tf._ds = {};
        this.tf.Layer_line = null; //台风线段图层
        this.tf.Layer_line = this._createLayer(this.options.layerOrder.trackLine, this.map);
        
        this.tf.Layer_point = null; //台风路径点图层
        this.tf.Layer_point = this._createLayer(this.options.layerOrder.trackPoint, this.map);
        
        this.tf.selectPoint = null; //台风路径点 Focus图层
        this.tf.selectPoint = this._createLayer(this.options.layerOrder.focusPoint, this.map);
        
        this.tf.Layer_label = null; //台风标注图层 trackLabel
        this.tf.Layer_label = this._createLayer(this.options.layerOrder.trackLabel, this.map);
        
        this.tf.Layer_Circle = {}; //风圈
        // this.tf.Layer_Forcast_Polygon = {};
        //this.tf.Layer_Circle = this._createLayer(this.options.layerOrder.typhoonRing, this.map);
        //预报图层
        this.tf.Layer_forecast = {};
        //this.tf.Layer_forecast = this._createLayer(this.options.layerOrder.typhoonForecast, this.map);
    },
    //初始化对外接口消息
    _initInterfaceMsg: function (options) {
        var trackPointEvent = options.interfaceMsg.trackPoint;
        var forecastPointEvent = options.interfaceMsg.forecastPoint;
        if (CommonUtil.isObject(trackPointEvent)) {
            options.interfaceMsg.trackPoint = [trackPointEvent];
        }
        if (CommonUtil.isObject(forecastPointEvent)) {
            options.interfaceMsg.forecastPoint = [forecastPointEvent];
        }
        this.options.interfaceMsg = {
            'forecastPoint': [{
                'name': 'mousemoveForecastPoint',
                'enable': 1,
            }],
            'trackPoint': [{
                'name': 'mouseoverTrackPoint',
                'enable': 1,
            }]
        };
        this.options.interfaceMsg.forecastPoint = this._mergeOptions(this.options.interfaceMsg.forecastPoint, options.interfaceMsg.forecastPoint);
        this.options.interfaceMsg.trackPoint = this._mergeOptions(this.options.interfaceMsg.trackPoint, options.interfaceMsg.trackPoint);
    },
    
    //转换成地图缺省坐标
    _transformMap: function (oldGeo) {
        if (this.options.dataSpatialReference == this.map.spatialReference) { return oldGeo }
        ;
        var pro = new g2.sfs.CoordinateTransform();
        var pp = pro.transform(oldGeo, this.options.map.spatialReference);
        return pp;
    },
    //转换成数据缺省坐标
    _transformData: function (oldGeo) {
        if (this.options.dataSpatialReference == this.map.spatialReference) { return oldGeo }
        ;
        var pro = new g2.sfs.CoordinateTransform();
        var pp = pro.transform(oldGeo, this.options.dataSpatialReference);
        return pp;
    },
    //地图坐标转换为指定空间索引的坐标
    _transformObj: function (oldGeo, dstSpatialReference) {
        if (dstSpatialReference == this.map.spatialReference) { return oldGeo }
        ;
        var pro = new g2.sfs.CoordinateTransform();
        var pp = pro.transform(oldGeo, dstSpatialReference);
        return pp;
    },
    
    //load current year active typhoon
    // _loadCurrentTyphoon: function () {
    //     //load current typhoon
    //     var dataYear = new Date().getFullYear();
    //     var thisObj = this;
    //     this.service.getTyphoonsByYear({ year: dataYear }).then(function (data) {
    //         var dataObj = data
    //         if (dataObj.status == 1) {
    //             for (var i = 0, j = 0; i < dataObj.data.length; i++) {
    //                 if (dataObj.data[i].is_current == 1) {
    //                     thisObj.loadOneTyphoon(dataObj.data[i].id);
    //                     j++;
    //                 }
    //             }
    //             if (j == 0) {
    //                 var info = year + '! Currently,there are no active typhoons !!!';
    //                 console.debug('----------', info);
    //             }
    //         }
    //     });
    // },
    
    /**
     * 查询url显示台风
     */
    _showTyphoonTrack: function (tfbh, visibleFlag, fit) {
        return new Promise((resolve, reject) => {
            var thisObj = this;
            var returnObj = {'status': -1, "data": ''};
            
            this.service.getTyphoonInfo({typhoonid: tfbh}).then(function (data) {
                var resultData = data;
                if (!!resultData) {
                    returnObj.status = 1;
                    returnObj.data = resultData[0]
                    if (resultData[0] == undefined) { return }
                    ;
                    // console.log(resultData[0]);
                    // var length = resultData[0].features.length;
                    // // TODO 这里一会儿改回去
                    // let list = [resultData[0].features[length - 3],resultData[0].features[length - 2],resultData[0].features[length - 1]];
                    // resultData[0].features = list;
                    thisObj._drawOneTyphoon(resultData[0], visibleFlag, fit);
                    
                    
                } else {
                    returnObj.status = -1;
                    returnObj.data = 'no data ! Please check data.....';
                }
                resolve();
            });
        })
        
    },
    /**
     * 查询url显示台风
     */
    _showTyphoonTrackData: function (data, visibleFlag, fit) {
        var thisObj = this;
        var returnObj = {'status': -1, "data": ''};
        
        if (!!data) {
            returnObj.status = 1;
            returnObj.data = data
            thisObj._drawOneTyphoon(data, visibleFlag, fit);
        } else {
            returnObj.status = -1;
            returnObj.data = 'no data ! Please check data.....';
        }
    },
    //绘制一条台风数据
    _drawOneTyphoon: function (oneData, visibleFlag, fit) {
        var tfbh = oneData.tfbh;
        this.clearOneTyphoon(tfbh);
        this.tf.paths[tfbh] = oneData;
        this._createlineById(tfbh, visibleFlag, fit);
        this._createPointById(tfbh, visibleFlag);
        this._createTyphoonLabel(tfbh, visibleFlag);
    },
    /*
     创建台风路径：线段集合
     */
    _createlineById: function (tfbh, visibleFlag) {
        var thisObj = this;
        thisObj.tf.realLine[tfbh] = [];
        // thisObj.tf.realPath = [];
        var myStyle = {
            "color": "black",
            "weight": 2,
            "opacity": 0.7
        };
        var lastArr;
        var lastEle;
        var isStart = true;
        for (let index = 0; index < thisObj.tf.paths[tfbh].features.length; index++) {
            const item = thisObj.tf.paths[tfbh].features[index];
            if (!isStart) {
                var polyline = new g2.sfs.Polyline({spatialReference: thisObj.options.dataSpatialReference});
                var path = new g2.sfs.Path({spatialReference: thisObj.options.dataSpatialReference});
                var point1 = new g2.sfs.Point({
                    //x: lastArr[0],
                    //y: lastArr[1],
                    x: lastEle.geometry.coordinates[0],
                    y: lastEle.geometry.coordinates[1],
                    spatialReference: thisObj.options.dataSpatialReference
                    //spatialReference: g2.sfs.SpatialReference.EPSG4326
                });
                var point2 = new g2.sfs.Point({
                    x: item.geometry.coordinates[0],
                    y: item.geometry.coordinates[1],
                    spatialReference: thisObj.options.dataSpatialReference
                    //spatialReference: g2.sfs.SpatialReference.EPSG4326
                });
                path.addPoint(point1);
                path.addPoint(point2);
                polyline.addGeometry(path);
                
                var lineColor = {a: 153, r: 0, g: 0, b: 0};
                if (thisObj.options.typhoon.lineColor != undefined) {
                    lineColor = thisObj.options.typhoon.lineColor;
                }
                var ploylineSymbol;
                if (thisObj.options.typhoon.lineSingleColorFlag > 0) {
                    ploylineSymbol = new g2.sfs.SimpleLineSymbol({
                        color: new g2.sfs.Color(lineColor)
                    });
                } else {
                    var objGrade = thisObj._getTyphoonGrade(item.properties.speed);
                    ploylineSymbol = new g2.sfs.SimpleLineSymbol({
                        color: new g2.sfs.Color.fromHex(objGrade.color)
                    });
                }
                polyline = thisObj._transformMap(polyline);
                var polylineElement = new g2.sfs.Element({geometry: polyline, symbol: ploylineSymbol});
                polylineElement._tfbh = tfbh;
                thisObj.tf.realLine[tfbh].push(polylineElement);
            }
            lastEle = item;
            isStart = false;
        }
        
        
        if (thisObj.tf.realLine[tfbh] && visibleFlag != false) {
            
            for (var j = 0; j < thisObj.tf.realLine[tfbh].length; j++) {
                var polylineElement = thisObj.tf.realLine[tfbh][j];
                //构造element实例
                
                //将element加入到图层中
                thisObj.tf.Layer_line.add(polylineElement);
            }
        }
    },
    /*
     创建台风点，并绘制
     */
    _createPointById: function (tfbh, visibleFlag, fit) {
        var thisObj = this;
        thisObj.tf.realPoints[tfbh] = [];
        var _len = thisObj.tf.paths[tfbh].features.length;
        for (var j = 0; j < _len; j++) {
            var speed = thisObj.tf.paths[tfbh].features[j].properties.speed;
            var style = thisObj._getTyphoonPointStyle(speed);
            var geo = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
                thisObj.tf.paths[tfbh].features[j].geometry,
                thisObj.options.dataSpatialReference
            );
            var markerSymbol = new g2.sfs.SimpleMarkerSymbol({
                    fillColor: g2.sfs.Color.fromHex(style.fillColor),
                    borderColor: g2.sfs.Color.fromHex(style.borderColor),
                    size: style.radius
                }
            );
            markerSymbol.fillColor.a = style.fillOpacity;
            markerSymbol.borderColor.a = style.opacity;
            geo = thisObj._transformMap(geo);
            var ele = new g2.sfs.Element({geometry: geo, symbol: markerSymbol});
            ele._data = thisObj.tf.paths[tfbh].features[j];
            ele._tfbh = tfbh;
            //标识是否为最后点位
            ele.islast = (j == _len - 1);
            if (visibleFlag != false) {
                thisObj.tf.Layer_point.add(ele);
            }
            
            thisObj.tf.realPoints[tfbh].push(ele);
        }
        var envelope = thisObj._getBoundRect(thisObj.tf.paths[tfbh].features);
        //缩放外界矩形到视野范围
        if (fit != false) {
            thisObj.map.pan(envelope, [200, 200, 200, 200]);
        }
    },
    //求最佳外接矩形
    _getBoundRect: function (features) {
        var minx = 180, miny = 90, maxx = -180, maxy = -90;
        var thisObj = this;
        var detaData = 2;
        var detaData = 2;
        if (thisObj.options.projection == 0) {
            detaData = 10000;
            if (thisObj.options.rect != undefined) {
                if (thisObj.options.rect.maxx != undefined) {
                    minx = thisObj.options.rect.maxx;
                }
                if (thisObj.options.rect.maxy != undefined) {
                    miny = thisObj.options.rect.maxy;
                }
                if (thisObj.options.rect.minx != undefined) {
                    maxx = thisObj.options.rect.minx;
                }
                if (thisObj.options.rect.miny != undefined) {
                    maxy = thisObj.options.rect.miny;
                }
                if (thisObj.options.rect.noMinx != undefined) {
                    minx = thisObj.options.rect.minx;
                }
                if (thisObj.options.rect.noMaxy != undefined) {
                    maxy = thisObj.options.rect.maxy;
                }
            }
        }
        for (var j = 0; j < features.length; j++) {
            var geo = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
                features[j].geometry,
                thisObj.options.dataSpatialReference
            );
            //求最佳外接矩形
            if (minx > geo.x) {
                minx = geo.x
            }
            if (miny > geo.y) {
                miny = geo.y
            }
            if (maxx < geo.x) {
                maxx = geo.x
            }
            if (maxy < geo.y) {
                maxy = geo.y
            }
        }
        if (features.length == 1) {
            minx = minx - detaData;// 2;
            miny = miny - detaData;//2;
            maxx = maxx + detaData;//2;
            maxy = maxy + detaData;//2;
        }
        var p1 = new g2.sfs.Point({
            x: minx,
            y: miny,
            spatialReference: thisObj.options.dataSpatialReference
        });
        p1 = thisObj._transformMap(p1);
        var p2 = new g2.sfs.Point({
            x: maxx,
            y: maxy,
            spatialReference: thisObj.options.dataSpatialReference
        });
        p2 = thisObj._transformMap(p2);
        var envelope = new g2.sfs.Envelope({
            minx: p1.x, maxx: p2.x,
            miny: p1.y, maxy: p2.y,
            spatialReference: thisObj.options.spatialReference
        });
        return envelope;
    },
    /*
     *创建台风名称标注
     * @param tfbh  台风标号
     */
    _createTyphoonLabel: function (tfbh, visibleFlag) {
        var ele = this.tf.realPoints[tfbh][0];
        var cname = this.tf.paths[tfbh].name;
        if (this.tf.paths[tfbh].name == '-') {
            cname = this.tf.paths[tfbh].ename;
        }
        var label = tfbh + '\n' + cname;
        var txtSymInt = this.options.typhoon.nameTextSymbol;
        var textSymbol = new g2.sfs.TextSymbol({
            text: label,
            fontSize: txtSymInt.fontSize,
            fontWeight: txtSymInt.fontWeight,
            fontFamilyName: txtSymInt.fontFamilyName,
            foreground: new g2.sfs.Color(txtSymInt.foreground),
            borderColor: new g2.sfs.Color(txtSymInt.borderColor),
            offsetY: txtSymInt.offsetY,
            borderThickness: txtSymInt.borderThickness
        });
        var oGeo = ele.geometry;
        var pointEle = new g2.sfs.Element({geometry: oGeo, symbol: textSymbol});
        if (visibleFlag != false) {
            this.tf.Layer_label.add(pointEle);
        }
        
        this.tf.realLabels[tfbh] = pointEle;
    },
    
    
    /*
     *台风路径焦点特效
     * @param element  台风路径点对象
     */
    _createFocusPoint: function (element) {
        if (element._data == undefined) return;
        var thisObj = this;
        thisObj.tf.selectPoint.clear();
        var style = this.options.typhoon.focusPointSymbol;
        var geo = g2.sfs.GeometryFactory.createGeometryFromGeoJson(element._data.geometry,
            thisObj.options.dataSpatialReference);
        var markerSymbol = new g2.sfs.SimpleMarkerSymbol({
                fillColor: g2.sfs.Color.fromHex(style.fillColor),
                borderColor: g2.sfs.Color.fromHex(style.borderColor),
                size: style.radius
            }
        );
        markerSymbol.fillColor.a = style.fillOpacity;
        markerSymbol.borderColor.a = style.opacity;
        geo = thisObj._transformMap(geo);
        var ele = new g2.sfs.Element({geometry: geo, symbol: markerSymbol});
        ele._data = element._data;
        ele._tfbh = element._tfbh;
        thisObj.tf.selectPoint.add(ele);
    },
    
    //layer(标绘点的图层)
    _addTyphoonIconById: function (tfbh, lastEle, interval) {
        
        //获取台风路径最后一个
        if (lastEle == undefined) {
            lastEle = this.tf.realPoints[tfbh][this.tf.realPoints[tfbh].length - 1];
            this.tyhoonPlayFlag = 0;
        }
        ;
        
        var rotation = 360;
        var thisObj = this;
        window.clearInterval(this.tf.typhoonInterval[tfbh]);
        this.tf.typhoonIconLayer.clear();
        this.tf.typhoonInterval[tfbh] = window.setInterval(function () {
            thisObj.tf.typhoonIconLayer.clear();
            //循环遍历地图上的要素
            var markerSymbol = new g2.sfs.PictureMarkerSymbol({
                source: thisObj.options.picSymbol.typhoonIcon,
                width: "50", height: "50",
                rotation: rotation + '',
                opacity: "1",
                offsetX: "23",
                offsetY: "23"
            });
            var ele = new g2.sfs.Element({geometry: lastEle.geometry, symbol: markerSymbol});
            //往台风图层上追加图标
            thisObj.tf.typhoonIconLayer.add(ele);
            //改变旋转角度
            rotation -= 20;
            if (rotation == 0) {
                rotation = 360;
            }
        }, interval / 5)
        
    },
    
    /*
     * 根据风速获取台风点样式对象
     * @param speed  风速,单位 米/秒（m/s）
     */
    _getTyphoonPointStyle: function (speed) {
        speed = speed ? speed : 0;
        var obj = this._getTyphoonGrade(speed);
        var pointStyle = {
            fillColor: obj.color,
            borderColor: '#80808C',
            weight: 0.5,
            opacity: 153,
            fillOpacity: 255,
            // lineCap:'round',
            fill: true,
            // zIndexOffset:5
            radius: 5
        };
        return pointStyle;
        
    },
    
    /*
     *获取台风等级对象
     * @param speed  风速,单位 米/秒（m/s）
     */
    _getTyphoonGrade: function (speed) {
        var speeds = this.options.typhoon.typhoonSpeeds;
        var colors = this.options.typhoon.typhoonPointColor;
        var levels = this.options.typhoon.typhoonLevel;
        var index = -1;
        if ((speed == null) || (speed == undefined)) {
            speed = 0;
        }
        speed = speed.toFixed(1);
        //极小值处理
        var minSpeed = speeds[0][0];
        if (speed < minSpeed) {
            index = 0;
        }
        //极大值处理
        var maxSpeed = speeds[speeds.length - 1][1];
        if (speed > maxSpeed) {
            index = speeds.length - 1;
        }
        if (index == -1) {
            for (var i = 0; i < speeds.length; i++) {
                var arr = speeds[i];
                var minSp = arr[0];
                var maxSp = arr[1];
                if (((speed == minSp) || (speed > minSp))
                    && ((speed == maxSp) || (speed < maxSp))) {
                    index = i
                    break;
                }
            }
        }
        return {
            color: colors[index],
            level: levels[index]
        }
    },
    
    _getRegineColor: function (regionCode) {
        var color = null;
        color = this.options.forecast.org[regionCode.trim()].rgb;
        if (color == undefined) {
            
            color = this.options.forecast.org['null'];
        }
        color = new g2.sfs.Color.fromHex(color);
        //线型为2——DashDotDot
        var polylineSymbol = new g2.sfs.SimpleLineSymbol({
            color: color,
            width: this.options.forecast.lineStyle.width,
            style: this.options.forecast.lineStyle.style
        });
        polylineSymbol.color.a = this.options.forecast.lineStyle.opacity;
        return polylineSymbol;
    },
    /**
     * 机构预报信息清除
     */
    _forecastsClear: function () {
        if (!this.tf.Layer_forecast) return;
        for (var key in this.tf.Layer_forecast) {
            this.tf.Layer_forecast[key].clear();
            //this.tf.Layer_forecast.clear();
        }
        this.tf.forecastPoints = {};
        this.tf.forecastLines = {};
        this.tf.forecastPolygons = {};
    },
    /**
     * 机构预报信息清除
     */
    _forecastsClearByTfbh: function (tfbh) {
        if (!this.tf.Layer_forecast) return;
        this.tf.Layer_forecast[tfbh].clear();
        // for (var i = 0; i < this.tf.forecastPoints[tfbh].length; i++) {
        //     this.tf.Layer_forecast.remove(this.tf.forecastPoints[tfbh][i]);
        // }
        // for (var j = 0; j < this.tf.forecastPoints[tfbh].length; j++) {
        //     this.tf.Layer_forecast.remove(this.tf.forecastPoints[tfbh][j]);
        // }        
        this.tf.forecastPoints[tfbh] = {};
        this.tf.forecastLines[tfbh] = {};
        this.tf.forecastPolygons[tfbh] = {};
        
    },
    /**
     * 各个机构预报信息展示
     */
    _drawForecasts: function (element) {
        var thisObj = this;
        if (!thisObj.tf.forecastPoints[element._tfbh]) {
            thisObj.tf.forecastPoints[element._tfbh] = {};
        }
        if (!thisObj.tf.forecastLines[element._tfbh]) {
            thisObj.tf.forecastLines[element._tfbh] = {};
        }
        if (!thisObj.tf.forecastPolygons[element._tfbh]) {
            thisObj.tf.forecastPolygons[element._tfbh] = {};
        }
        if (!thisObj.tf.Layer_forecast[element._tfbh]) {
            thisObj.tf.Layer_forecast[element._tfbh] = thisObj._createLayer(thisObj.options.layerOrder.typhoonForecast, this.map);
        } else {
            thisObj._forecastsClearByTfbh(element._tfbh);
        }
        let tfInfo = this.tf.paths[element._tfbh];
        let name, nameEn;
        if (tfInfo) {
            if ((tfInfo.name == '-') || (tfInfo.name == '')) {
                name = tfInfo.ename;
            }else {
                name = tfInfo.name;
            }
            nameEn = tfInfo.ename;
        }
        for (var i = 0; i < element._data.properties.forecast.length; i++) {
            var item = element._data.properties.forecast[i];
            
            /*添加预测路径*/
            var path = new g2.sfs.Path({
                    spatialReference: thisObj.options.spatialReference
                }
            );
            //todo 必须显式严格声明,fixed ts-gis 2.0 beta bug;
            path.addPoint(new g2.sfs.Point({
                x: parseFloat(element.geometry.x),
                y: parseFloat(element.geometry.y),
                spatialReference: thisObj.options.spatialReference
            }));
            
            for (var j = 0; j < item.features.length; j++) {
                var subitem = item.features[j];
                //下述geometry可能不是geometry对象
                var point = new g2.sfs.Point({
                    x: subitem.geometry.coordinates[0],
                    y: subitem.geometry.coordinates[1],
                    spatialReference: thisObj.options.spatialReference
                });
                //var markerSymbol = thisObj.getStrongStyle(subitem.properties.speed);
                var objStyle = thisObj._getTyphoonPointStyle(subitem.properties.speed);
                var markerSymbol = new g2.sfs.SimpleMarkerSymbol({
                    fillColor: new g2.sfs.Color.fromHex(objStyle.fillColor),
                    borderColor: new g2.sfs.Color.fromHex(objStyle.borderColor),//"#80808C"
                    size: objStyle.radius - 1
                });
                var pointMarker = new g2.sfs.Element({geometry: point, symbol: markerSymbol});
                subitem.region_ab = item.region_ab;
                subitem.region = item.region;
                subitem.tfName = name;
                subitem.tfNameEn = nameEn;
                subitem.tfbh = element._tfbh;
                pointMarker.data_user = subitem;
                pointMarker._forecast = 1;//ts-gis hiTest无法区分图层
                
                if (this.tf.forecastPoints[element._tfbh][subitem.region] == undefined) {
                    this.tf.forecastPoints[element._tfbh][subitem.region] = [];
                }
                this.tf.forecastPoints[element._tfbh][subitem.region].push(pointMarker);
                this.tf.Layer_forecast[element._tfbh].add(pointMarker);
                this.tf.Layer_forecast[element._tfbh].showElement(pointMarker, this.options.forecast.org[subitem.region].display);
                // this.tf.Layer_forecast.add(pointMarker);
                // this.tf.Layer_forecast.showElement(pointMarker, this.options.forecast.org[subitem.region].display);
                path.addPoint(point);
            }
            var polyline = new g2.sfs.Polyline({
                spatialReference: thisObj.options.spatialReference
            });
            polyline.addGeometry(path);
            var ploylineSymbol = thisObj._getRegineColor(item.region);
            var polylineElement = new g2.sfs.Element({geometry: polyline, symbol: ploylineSymbol});
            this.tf.Layer_forecast[element._tfbh].add(polylineElement);
            this.tf.Layer_forecast[element._tfbh].showElement(polylineElement, this.options.forecast.org[subitem.region].display);
            // this.tf.Layer_forecast.add(polylineElement);
            // this.tf.Layer_forecast.showElement(polylineElement, this.options.forecast.org[subitem.region].display);            
            this.tf.forecastLines[element._tfbh][item.region] = polylineElement;
        }
    },
    /**
     * 风圈信息清理
     */
    _clearCircle: function () {
        if (!this.tf.Layer_Circle) return;
        for (var key in this.tf.Layer_Circle) {
            this.tf.Layer_Circle[key].clear();
        }
        
        this.tf.selectPoint.clear();
    },
    /**
     * 风圈信息清理
     */
    _clearCircleByTfbh: function (tfbh) {
        if (!this.tf.Layer_Circle[tfbh]) return;
        this.tf.Layer_Circle[tfbh].clear();
        this.tf.selectPoint.clear();
    },
    //显示路径关键点(弹框+预测)
    _showRoutePointPopup: function (element) {
        var self = this;
        var oneEle = null;
        oneEle = element;
        if (oneEle._data == undefined) { return }
        if (oneEle._data.properties == undefined) { return }
        //绘制风圈
        self._drawCircle(oneEle);
        //绘制各机构预报信息
        self._drawForecasts(oneEle);
        // self._getForecastCircleTan(oneEle);
        
    },
    //显示风圈
    _getTyphoonCircleInfo: function (element) {
        var self = this;
        var oneEle = null;
        oneEle = element;
        if (oneEle._data == undefined) { return }
        if (oneEle._data.properties == undefined) { return }
        //绘制风圈
        var result = self._getCircle(oneEle);
        result = self._typhoonCircle2Ring(result, "ne");
        result = self._typhoonCircle2Ring(result, "nw");
        result = self._typhoonCircle2Ring(result, "se");
        result = self._typhoonCircle2Ring(result, "sw");
        
        if (result.grade_7) {
            result = this._getUnionedGeom(result, "grade_7")
        }
        if (result.grade_10) {
            result = this._getUnionedGeom(result, "grade_10")
        }
        if (result.grade_12) {
            result = this._getUnionedGeom(result, "grade_12")
        }
        return result;
    },
    
    _getUnionedGeom: function (result, grade) {
        var reader = new jsts.io.GeoJSONReader();
        var _geom_ne = reader.read(result[grade].ne.geom);
        var _geom_nw = reader.read(result[grade].nw.geom);
        var _geom_se = reader.read(result[grade].se.geom);
        var _geom_sw = reader.read(result[grade].sw.geom);
        var _geom = _geom_ne.union(_geom_nw).union(_geom_se).union(_geom_sw);
        var GeoJSONWriter = new jsts.io.GeoJSONWriter();
        result[grade].geom = GeoJSONWriter.write(_geom);
        return result;
    },
    _typhoonCircle2Ring: function (obj, direction) {
        var GeoJSONWriter = new jsts.io.GeoJSONWriter();
        var ring_12, ring_10, ring_7
        if (obj.grade_12 && obj.grade_12[direction] && obj.grade_12[direction].geom) {
            ring_12 = obj.grade_12[direction].geom;
            ring_10 = obj.grade_10[direction].geom.difference(obj.grade_12[direction].geom);
            ring_7 = obj.grade_7[direction].geom.difference(obj.grade_10[direction].geom);
        } else if (obj.grade_10 && obj.grade_10[direction] && obj.grade_10[direction].geom) {
            ring_10 = obj.grade_10[direction].geom;
            ring_7 = obj.grade_7[direction].geom.difference(obj.grade_10[direction].geom);
        } else if (obj.grade_7 && obj.grade_7[direction] && obj.grade_7[direction].geom) {
            ring_7 = obj.grade_7[direction].geom;
        }
        
        if (obj.grade_7) {
            obj.grade_7[direction].geom = ring_7 ? GeoJSONWriter.write(ring_7) : null;
        }
        if (obj.grade_10) {
            obj.grade_10[direction].geom = ring_10 ? GeoJSONWriter.write(ring_10) : null;
        }
        if (obj.grade_12) {
            obj.grade_12[direction].geom = ring_12 ? GeoJSONWriter.write(ring_12) : null;
        }
        return obj;
    },
    //显示风圈
    _showTyphoonCircle: function (element) {
        var self = this;
        var oneEle = null;
        oneEle = element;
        if (oneEle._data == undefined) { return }
        if (oneEle._data.properties == undefined) { return }
        //绘制风圈
        self._drawCircle(oneEle);
    },
    //显示预测线
    _showTyphoonForecast: function (element) {
        var self = this;
        var oneEle = null;
        oneEle = element;
        if (oneEle._data == undefined) { return }
        if (oneEle._data.properties == undefined) { return }
        //绘制各机构预报信息
        self._drawForecasts(oneEle);
    },
    //显示预测点的弹出信息框
    _showPopupForecast: function (element, uuid) {
        
        var feature = element.data_user;
        if (!feature) {
            return;
        }
        this.options.toolTipWare.clear();
        var thisObj = this;
        var popupContent = this._getForecastPopupContent(element, uuid);
        var tooltip = new g2.widget.Tooltip({
            anchor: element.geometry,     //提示在地图上停靠位置
            content: popupContent,  //提示内容
            //layerId: this.tf.Layer_forecast[element._tfbh].getLayerId(),//layer.getLayerId(), //提示所在图层ID
            //layerId: this.tf.Layer_forecast.getLayerId(),//layer.getLayerId(), //提示所在图层ID
            offset: [0, -10],     //位置偏移量
        });
        this.options.toolTipWare.add(tooltip);
    },
    
    _getForecastPopupContent: function (element, uuid) {
        var divStyle = 'font-size:12px;color:#000 ;background: #fff; margin-top: 8px;margin-left: 10px; margin-right: 0px;';
        if (this.options.popupForecast.divStyle != undefined) {
            divStyle = this.options.popupForecast.divStyle;
        }
        var popupContent = '<div id="' + uuid + '" style="' + divStyle + '">'
            + JSON.stringify(this._parseForecastData(element));
        +"</div>";
        return popupContent;
    },
    _getCircle: function (element) {
        var result = {};
        var feature = element._data
        var thisObj = this;
        var r7 = feature.properties.radius7_quad;
        var r10 = feature.properties.radius10_quad;
        var r12 = feature.properties.radius12_quad;
        //var center = [feature.geometry.coordinates[0], feature.geometry.coordinates[1]];
        var pp = new g2.sfs.Point({
            x: feature.geometry.coordinates[0],
            y: feature.geometry.coordinates[1],
            spatialReference: thisObj.options.dataSpatialReference
        });
        pp = thisObj._transformMap(pp);
        var center = [pp.x, pp.y];
        var ne, se, sw, nw;
        
        //12级风圈
        if ((r7 == null) && (r10 == null) && (r12 == null)) {
            var radius7 = feature.properties.radius7,
                radius10 = feature.properties.radius10,
                radius12 = feature.properties.radius12;
            //7级风圈
            if (radius7 != null) {
                var radius7_quad = {"ne": radius7, "se": radius7, "sw": radius7, "nw": radius7};
                var opts = {
                    "center": center, "radius": 0,
                    direction: "ne", radiusQuad: radius7_quad
                };
                result.grade_7 = this._getRing(opts);
            }
            //10级风圈
            if (radius10 != null) {
                var radius10_quad = {"ne": radius10, "se": radius10, "sw": radius10, "nw": radius10};
                var opts = {
                    "center": center, "radius": radius10,
                    direction: "ne"
                    , radiusQuad: radius10_quad
                };
                result.grade_10 = this._getRing(opts);
            }
            //	12级风圈
            if (radius12 != null) {
                var radius12_quad = {"ne": radius12, "se": radius12, "sw": radius12, "nw": radius12};
                var opts = {
                    "center": center, "radius": radius12,
                    direction: "ne"
                    , radiusQuad: radius12_quad
                };
                result.grade_12 = this._getRing(opts);
            }
        } else {
            //	7级风圈
            if (r7.ne > 0) {
                var opts = {
                    "center": center, "radius": 0,
                    direction: "ne", radiusQuad: feature.properties.radius7_quad
                };
                result.grade_7 = this._getRing(opts);
            }
            //10级风圈
            if (r10.ne > 0) {
                var opts = {
                    "center": center, "radius": radius10,
                    direction: "ne"
                    , radiusQuad: feature.properties.radius10_quad
                };
                result.grade_10 = this._getRing(opts);
            }
            //12级风圈
            if (r12.ne > 0) {
                var opts = {
                    "center": center, "radius": radius12,
                    direction: "ne"
                    , radiusQuad: feature.properties.radius12_quad
                };
                result.grade_12 = this._getRing(opts);
            }
        }
        
        return result;
    },
    _getRing: function (opts) {
        var result = {};
        opts.direction = "ne";
        opts.radius = opts.radiusQuad.ne;
        result[opts.direction] = {};
        result[opts.direction].geom = GeometryUtil.toJstsGeometry(this._getRingArcGeom(opts));
        opts.direction = "nw";
        opts.radius = opts.radiusQuad.nw;
        result[opts.direction] = {};
        result[opts.direction].geom = GeometryUtil.toJstsGeometry(this._getRingArcGeom(opts));
        opts.direction = "sw";
        opts.radius = opts.radiusQuad.sw;
        result[opts.direction] = {};
        result[opts.direction].geom = GeometryUtil.toJstsGeometry(this._getRingArcGeom(opts));
        opts.direction = "se";
        opts.radius = opts.radiusQuad.se;
        result[opts.direction] = {};
        result[opts.direction].geom = GeometryUtil.toJstsGeometry(this._getRingArcGeom(opts));
        return result;
    },
    /**
     * 绘制风圈
     */
    _drawCircle: function (element) {
        var feature = element._data
        var thisObj = this;
        if (!this.tf.Layer_Circle[element._tfbh]) {
            this.tf.Layer_Circle[element._tfbh] = this._createLayer(this.options.layerOrder.typhoonRing, this.map);
        } else {
            this._clearCircleByTfbh(element._tfbh);
        }
        
        var r7 = feature.properties.radius7_quad;
        var r10 = feature.properties.radius10_quad;
        var r12 = feature.properties.radius12_quad;
        //var center = [feature.geometry.coordinates[0], feature.geometry.coordinates[1]];
        var pp = new g2.sfs.Point({
            x: feature.geometry.coordinates[0],
            y: feature.geometry.coordinates[1],
            spatialReference: thisObj.options.dataSpatialReference
        });
        pp = thisObj._transformMap(pp);
        var center = [pp.x, pp.y];
        var ne, se, sw, nw;
        
        var radius7_style = {
            color: '#42A53C',
            fillColor: '#42A53C',
            opacity: 153,
            fillOpacity: 153,
            weight: 0
        };
        var radius10_style = {
            color: '#FFAA00',
            fillColor: '#FFAA00',
            opacity: 153,
            fillOpacity: 153,
            weight: 0
        };
        var radius12_style = {
            color: '#F2360E',
            fillColor: '#F2360E',
            opacity: 153,
            fillOpacity: 153,
            weight: 0
        };
        
        
        //12级风圈
        if ((r7 == null) && (r10 == null) && (r12 == null)) {
            var radius7 = feature.properties.radius7,
                radius10 = feature.properties.radius10,
                radius12 = feature.properties.radius12;
            //7级风圈
            if (radius7 != null) {
                //0.00027=31m,1=111km,1'=1.85km,1''=30.9m
                //var radius= radius7 /111;
                var radius7_quad = {"ne": radius7, "se": radius7, "sw": radius7, "nw": radius7};
                var opts = {
                    "layer": this.tf.Layer_Circle[element._tfbh],
                    "center": center, "radius": 0,
                    "style": radius7_style, direction: "ne", radiusQuad: radius7_quad
                };
                this._drawRing(opts);
            }
            //10级风圈
            if (radius10 != null) {
                var radius10_quad = {"ne": radius10, "se": radius10, "sw": radius10, "nw": radius10};
                var opts = {
                    "layer": this.tf.Layer_Circle[element._tfbh],
                    "center": center, "radius": radius10,
                    "style": radius10_style, direction: "ne"
                    , radiusQuad: radius10_quad
                };
                this._drawRing(opts);
            }
            //	12级风圈
            if (radius12 != null) {
                var radius12_quad = {"ne": radius12, "se": radius12, "sw": radius12, "nw": radius12};
                var opts = {
                    "layer": this.tf.Layer_Circle[element._tfbh],
                    "center": center, "radius": radius12,
                    "style": radius12_style, direction: "ne"
                    , radiusQuad: radius12_quad
                };
                this._drawRing(opts);
            }
        } else {
            //	7级风圈
            if (r7.ne > 0) {
                var opts = {
                    "layer": this.tf.Layer_Circle[element._tfbh],
                    "center": center, "radius": 0,
                    "style": radius7_style, direction: "ne", radiusQuad: feature.properties.radius7_quad
                };
                this._drawRing(opts);
            }
            //10级风圈
            if (r10.ne > 0) {
                var opts = {
                    "layer": this.tf.Layer_Circle[element._tfbh],
                    "center": center, "radius": radius10,
                    "style": radius10_style, direction: "ne"
                    , radiusQuad: feature.properties.radius10_quad
                };
                this._drawRing(opts);
            }
            //12级风圈
            if (r12.ne > 0) {
                var opts = {
                    "layer": this.tf.Layer_Circle[element._tfbh],
                    "center": center, "radius": radius12,
                    "style": radius12_style, direction: "ne"
                    , radiusQuad: feature.properties.radius12_quad
                };
                this._drawRing(opts);
            }
        }
    },
    
    _drawRing: function (opts) {
        opts.direction = "ne";
        opts.radius = opts.radiusQuad.ne;
        this._drawRingArc(opts);
        opts.direction = "nw";
        opts.radius = opts.radiusQuad.nw;
        this._drawRingArc(opts);
        opts.direction = "sw";
        opts.radius = opts.radiusQuad.sw;
        this._drawRingArc(opts);
        opts.direction = "se";
        opts.radius = opts.radiusQuad.se;
        this._drawRingArc(opts);
    },
    _drawRingArc: function (opts) {
        //构造扇形的填充色、边框色和线宽
        var symbol = new g2.sfs.SimpleFillSymbol({
            borderThickness: 0.01,
            fillColor: new g2.sfs.Color.fromHex(opts.style.fillColor),
            borderColor: new g2.sfs.Color.fromHex(opts.style.color)
        });
        symbol.fillColor.a = opts.style.fillOpacity;
        symbol.borderColor.a = opts.style.opacity;
        var geom = this._getRingArcGeom(opts)
        //构造element实例
        var polygonEle1 = new g2.sfs.Element({geometry: geom, symbol: symbol});
        opts.layer.add(polygonEle1);
    },
    
    _getRingArcGeom: function (opts) {
        var pps = this._arcPointsConstructor[opts.direction](opts.center, opts.radius, this.options.projection);
        var startP = pps.startP;
        var endP = pps.endP;
        
        //0.00027=31m,1=111km,1'=1.85km,1''=30.9m
        //构造第一个扇形的三个点，第一个点是圆心 第二点和第三个点是扇形的两个端点
        var plot1 = new g2.sfs.Plot();
        var controlls1 = [];
        var point11 = new g2.sfs.Point({
            x: opts.center[0],
            y: opts.center[1],
            spatialReference: this.options.spatialReference
        });
        var point12 = new g2.sfs.Point({
            x: startP[0],
            y: startP[1],
            spatialReference: this.options.spatialReference
        });
        var point13 = new g2.sfs.Point({
            x: endP[0],
            y: endP[1],
            spatialReference: this.options.spatialReference
        });
        controlls1.push(point11);
        controlls1.push(point12);
        controlls1.push(point13);
        plot1.controlPoints = controlls1;
        //实例化扇形算法
        var sectoralgorithm1 = new g2.plot.SectorAlgorithm();
        var sectorPolygon1 = sectoralgorithm1.createGeometries(plot1, null);
        return sectorPolygon1[0];
    },
    _arcPointsConstructor: {
        "ne": function (center, radius, projection) {
            //"0,90",
            var startP = new Array(2), endP = new Array(2);
            if (projection == 0) {
                startP[0] = center[0] + radius * 1000;
            } else {
                startP[0] = center[0] + radius / 111;
            }
            startP[1] = center[1];
            endP[0] = center[0];
            if (projection == 0) {
                endP[1] = center[1] + radius * 1000;
            } else {
                endP[1] = center[1] + radius / 111;
            }
            return {
                "startP": startP,
                "endP": endP
            }
        },
        "nw"://"90,180"
            function (center, radius, projection) {
                var startP = new Array(2), endP = new Array(2);
                startP[0] = center[0];
                if (projection == 0) {
                    startP[1] = center[1] + radius * 1000;
                } else {
                    startP[1] = center[1] + radius / 111;
                }
                if (projection == 0) {
                    endP[0] = center[0] - radius * 1000;
                } else {
                    endP[0] = center[0] - radius / 111;
                }
                endP[1] = center[1];
                return {
                    "startP": startP,
                    "endP": endP
                }
            },
        "sw"://"180,270",
            function (center, radius, projection) {
                var startP = new Array(2), endP = new Array(2);
                if (projection == 0) {
                    startP[0] = center[0] - radius * 1000;
                } else {
                    startP[0] = center[0] - radius / 111;
                }
                startP[1] = center[1];
                endP[0] = center[0];
                if (projection == 0) {
                    endP[1] = center[1] - radius * 1000;
                } else {
                    endP[1] = center[1] - radius / 111;
                }
                return {
                    "startP": startP,
                    "endP": endP
                }
            },
        "se": function (center, radius, projection) {
            //"270,360",
            var startP = new Array(2), endP = new Array(2);
            startP[0] = center[0];
            if (projection == 0) {
                startP[1] = center[1] - radius * 1000;
            } else {
                startP[1] = center[1] - radius / 111;
            }
            if (projection == 0) {
                endP[0] = center[0] + radius * 1000;
            } else {
                endP[0] = center[0] + radius / 111;
            }
            endP[1] = center[1];
            return {
                "startP": startP,
                "endP": endP
            }
        }
    },
    /**
     * 订制台风点弹出泡泡
     * @param element
     * @param layer
     */
    _showPopup: function (element, layer, uuid) {
        if (element._data == undefined) return;
        
        //先清除之前的popup
        this.options.toolTipWare.clear();
        
        var popupContent = this._getTrackPopupContent(element, uuid);
        
        var offset = this.options.popup.offset;
        var tooltip = new g2.widget.Tooltip({
            anchor: element.geometry,     //提示在地图上停靠位置
            content: popupContent,  //提示内容
            layerId: layer.getLayerId(), //提示所在图层ID
            offset: offset,     //位置偏移量 [0, -10]
            //className: 'g2-tooltip'  //tooltip样式
        });
        this.options.toolTipWare.add(tooltip);
    },
    _getTrackPopupContent: function (element, uuid) {
        var thisObj = this;
        var divStyle = 'font-size:12px;color:#000 ;background: #fff; margin-top: 8px;margin-left: 10px; margin-right: 0px;';
        if (thisObj.options.popup.divStyle != undefined) {
            divStyle = thisObj.options.popup.divStyle;
        }
        var popupContent = "<div id='" + uuid + "' style='" + divStyle + "'>"
            + JSON.stringify(this._parseTrackData(element))
            + "</div>";
        return popupContent;
    },
    
    _updateEventsArray: function (trackPointEvent, forecastPointEvent) {
        this.trackClickEvent = [];
        this.trackMousemoveEvent = [];
        this.forecastClickEvent = [];
        this.forecastMousemoveEvent = [];
        for (let index = 0; index < trackPointEvent.length; index++) {
            const _event = trackPointEvent[index];
            if (_event.enable != 0 && _event.event == "click") {
                this.trackClickEvent.push(_event.name);
            } else if (_event.enable != 0 && _event.event == "mousemove") {
                this.trackMousemoveEvent.push(_event.name);
            }
        }
        for (let index = 0; index < forecastPointEvent.length; index++) {
            const _event = forecastPointEvent[index];
            if (_event.enable != 0 && _event.event == "click") {
                this.forecastClickEvent.push(_event.name);
            } else if (_event.enable != 0 && _event.event == "mousemove") {
                this.forecastMousemoveEvent.push(_event.name);
            }
        }
    },
    /***
     * 添加监听 todo  针对ts-emap的事件监听
     * @private
     */
    _addListeners: function () {
        var thisObj = this;
        var trackPointEvent = thisObj.options.interfaceMsg.trackPoint;
        var forecastPointEvent = thisObj.options.interfaceMsg.forecastPoint;
        
        this._updateEventsArray(trackPointEvent, forecastPointEvent)
        
        this._getMapClickListener = function (event) {
            var screenX = event.screenX,
                screenY = event.screenY;
            //台风路径点泡泡信息
            var objLayerPoint1 = thisObj.tf.Layer_point.hitTest(screenX, screenY);
            if (!!objLayerPoint1) {
                var element1 = objLayerPoint1.element;
                if (element1._tfbh == undefined) { return; }
                ;
                
                var uuid = CommonUtil.newUUID32();
                
                //轨迹点鼠标点击事件
                if (thisObj.trackClickEvent.length > 0) {
                    for (let index = 0; index < thisObj.trackClickEvent.length; index++) {
                        if (selfObj.options.popup.display == 1) {
                            //显示弹出信息框
                            selfObj._showPopup(element1, selfObj.tf.Layer_point, uuid);
                        }
                        const eventname = thisObj.trackClickEvent[index];
                        thisObj.fire(eventname, {
                            id: uuid,
                            data: selfObj._parseTrackData(element1)
                        });
                        
                    }
                }
                if (thisObj.options.interfaceMsg.trackPoint.enable == 1) {
                    
                }
                thisObj._showRoutePointPopup(element1);
            }
            
            //预测台风路径点泡泡信息
            var objForecastPoint = null;
            var objForecastPointArr = [];
            for (var key in thisObj.tf.Layer_forecast) {
                var _layer = thisObj.tf.Layer_forecast[key];
                var obj = _layer.hitTest(screenX, screenY);
                if (!!obj) {
                    objForecastPointArr.push(obj)
                }
            }
            if (objForecastPointArr.length > 0) {
                objForecastPoint = objForecastPointArr[0];
            }
            
            if (!!objForecastPoint) {
                var eleForecast = objForecastPoint.element;
                if (!eleForecast || eleForecast._forecast == undefined) { return; }
                ;
                var uuid = CommonUtil.newUUID32();
                
                //预测点鼠标点击事件
                if (thisObj.forecastClickEvent.length > 0) {
                    for (let index = 0; index < thisObj.forecastClickEvent.length; index++) {
                        if (thisObj.options.popupForecast.display == 1) {
                            //显示弹出信息框
                            thisObj._showPopupForecast(eleForecast, uuid);
                        }
                        const eventname = thisObj.forecastClickEvent[index];
                        thisObj.fire(eventname, {
                            id: uuid,
                            data: thisObj._parseForecastData(eleForecast)
                        });
                        
                    }
                }
            }
            
        };
        this.map.listen('click', this._getMapClickListener, this);
        
        var selfObj = this;
        this._getMapMouseMoveListener = function (event) {
            var screenX = event.screenX,
                screenY = event.screenY;
            
            selfObj.options.toolTipWare.clear();
            selfObj.tf.selectPoint.clear();
            var objLayerPoint = selfObj.tf.Layer_point.hitTest(screenX, screenY);
            if (!!objLayerPoint) {
                var uuid = CommonUtil.newUUID32();
                var element = objLayerPoint.element;
                selfObj._createFocusPoint(element);
                
                //轨迹点鼠标悬浮事件
                //if (thisObj.options.interfaceMsg.trackPoint.enable == 1) {
                if (selfObj.trackMousemoveEvent.length > 0) {
                    for (let index = 0; index < selfObj.trackMousemoveEvent.length; index++) {
                        if (selfObj.options.popup.display == 1) {
                            //显示弹出信息框
                            selfObj._showPopup(element, selfObj.tf.Layer_point, uuid);
                        }
                        const eventname = selfObj.trackMousemoveEvent[index];
                        selfObj.fire(eventname, {
                            id: uuid,
                            data: selfObj._parseTrackData(element)
                        });
                    }
                }
                //}                  
            }
            //预测台风路径点泡泡信息
            var objForecastPoint = null;
            var objForecastPointArr = [];
            for (var key in thisObj.tf.Layer_forecast) {
                var _layer = thisObj.tf.Layer_forecast[key];
                var obj = _layer.hitTest(screenX, screenY);
                if (!!obj) {
                    objForecastPointArr.push(obj)
                }
            }
            if (objForecastPointArr.length > 0) {
                objForecastPoint = objForecastPointArr[0];
            }
            
            if (!!objForecastPoint) {
                var eleForecast = objForecastPoint.element;
                if (!eleForecast || eleForecast._forecast == undefined) { return; }
                ;
                var uuid = CommonUtil.newUUID32();
                
                
                //预测点鼠标悬浮事件
                
                if (selfObj.forecastMousemoveEvent.length > 0) {
                    for (let index = 0; index < selfObj.forecastMousemoveEvent.length; index++) {
                        if (selfObj.options.popupForecast.display == 1) {
                            //显示弹出信息框
                            selfObj._showPopupForecast(eleForecast, uuid);
                        }
                        const eventname = selfObj.forecastMousemoveEvent[index];
                        selfObj.fire(eventname, {
                            id: uuid,
                            data: selfObj._parseForecastData(eleForecast)
                        });
                    }
                }
                //}                
            }
            
        };
        this.map.listen('mousemove', this._getMapMouseMoveListener, this);
    },
    
    _parseTrackData: function (element) {
        var needPoint = this._transformObj(element.geometry, this.options.popup.pointEPSG)
        if (this.options.popup.pointPrecision != undefined) {
            var dx = parseFloat(needPoint.x);
            var dy = parseFloat(needPoint.y);
            dx = dx.toFixed(this.options.popup.pointPrecision);
            dy = dy.toFixed(this.options.popup.pointPrecision);
            needPoint.x = dx;
            needPoint.y = dy;
        }
        
        var moveSpeed = element._data.properties.move_speed;
        var moveDir = element._data.properties.move_dir;
        var radius7 = element._data.properties.radius7_quad;
        var radius10 = element._data.properties.radius10_quad;
        var radius12 = element._data.properties.radius12_quad;
        var typhoonBh = element._tfbh;
        var typhoonName;
        let typhoonEName = this.tf.paths[typhoonBh].ename;
        
        
        if ((this.tf.paths[typhoonBh].name == '-') || (this.tf.paths[typhoonBh].name == '')) {
            typhoonName = this.tf.paths[typhoonBh].ename;
        } else {
            typhoonName = this.tf.paths[typhoonBh].name;
        }
        
        var passTime = element._data.properties.time
        passTime = passTime.replace("T", " ");
        var centerPressure = element._data.properties.pressure;
        var power = element._data.properties.power;
        var speed = element._data.properties.speed;
        var result = {
            typhoonBh: {
                label: this.options.popup.typhoonBh.label,
                data: element._tfbh
            },
            typhoonNameEn: {
                label: this.options.popup.typhoonNameEn.label,
                data: typhoonEName
            },
            typhoonName: {
                label: this.options.popup.typhoonName.label,
                data: typhoonName
            },
            passTime: {
                label: this.options.popup.passTime.label,
                data: passTime
            },
            centerPoint: {
                label: this.options.popup.centerPoint.label,
                unit: this.options.popup.centerPoint.unit,
                data: [needPoint.x, needPoint.y]
            },
            centerPressure: {
                label: this.options.popup.centerPressure.label,
                unit: this.options.popup.centerPressure.unit,
                data: centerPressure
            },
            power: {
                label: this.options.popup.power.label,
                unit: this.options.popup.power.unit,
                data: power
            },
            speed: {
                label: this.options.popup.speed.label,
                unit: this.options.popup.speed.unit,
                data: speed
            },
            moveSpeed: {
                label: this.options.popup.moveSpeed.label,
                unit: this.options.popup.moveSpeed.unit,
                data: moveSpeed
            },
            moveDir: {
                label: this.options.popup.moveDir.label,
                unit: this.options.popup.moveDir.unit,
                data: moveDir
            },
            radius7: {
                label: this.options.popup.sevenRingRadius.label,
                unit: this.options.popup.sevenRingRadius.unit,
                data: radius7
            },
            radius10: {
                label: this.options.popup.tenRingRadius.label,
                unit: this.options.popup.tenRingRadius.unit,
                data: radius10
            },
            radius12: {
                label: this.options.popup.twelveRingRadius.label,
                unit: this.options.popup.twelveRingRadius.unit,
                data: radius12
            },
            islast: {
                label: "是否为最新轨迹点位",
                data: element.islast
            }
        }
        return result;
    },
    
    _parseForecastData: function (element) {
        var feature = element.data_user;
        var pp1 = new g2.sfs.Point({
            x: feature.geometry.coordinates[0],
            y: feature.geometry.coordinates[1],
            spatialReference: this.options.dataSpatialReference
        });
        var needPoint = this._transformObj(pp1, this.options.popupForecast.pointEPSG);
        var arrivalTime = feature.properties.time.replace('T', ' ');
        var forecastOrg = feature.region;
        var power = feature.properties.power;
        var speed = feature.properties.speed;
        var centralPressure = feature.properties.pressure;
        var moveSpeed = feature.properties.move_speed;
        var moveDir = feature.properties.move_dir;
        var tfbh = feature.tfbh;
        var typhoonNameEn = feature.tfNameEn;
        var typhoonName = feature.tfName;
        var result = {
            typhoonBh: {
                label: this.options.popup.typhoonBh.label,
                data: tfbh
            },
            typhoonNameEn: {
                label: this.options.popup.typhoonNameEn.label,
                data: typhoonNameEn
            },
            typhoonName: {
                label: this.options.popup.typhoonName.label,
                data: typhoonName
            },
            forecastOrg: {
                label: this.options.popupForecast.org.label,
                data: forecastOrg
            },
            arrivalTime: {
                label: this.options.popupForecast.arrivalTime.label,
                data: arrivalTime
            },
            centerPoint: {
                label: this.options.popupForecast.centerPoint.label,
                unit: this.options.popupForecast.centerPoint.unit,
                data: [needPoint.x, needPoint.y]
            },
            power: {
                label: this.options.popupForecast.power.label,
                unit: this.options.popupForecast.power.unit,
                data: power
            },
            speed: {
                label: this.options.popupForecast.speed.label,
                unit: this.options.popupForecast.speed.unit,
                data: speed
            },
            centralPressure: {
                label: this.options.popupForecast.centralPressure.label,
                unit: this.options.popupForecast.centralPressure.unit,
                data: centralPressure
            },
            moveSpeed: {
                label: this.options.popupForecast.moveSpeed.label,
                unit: this.options.popupForecast.moveSpeed.unit,
                data: moveSpeed
            },
            moveDir: {
                label: this.options.popupForecast.moveDir.label,
                unit: this.options.popupForecast.moveDir.unit,
                data: moveDir
            }
        };
        return result;
    },
    _getString: function (data, dataObj) {
        if (data != null) {
            context = dataObj.label + data + dataObj.unit;
        }
        if (dataObj.display == 0) {
            context = '';
        }
        return context;
    },
    // todo  针对ts-gis map原生事件监听
    _addListeners_tsmap: function () {
        var thisObj = this;
        this._getMapClickListener_ts = function (button, shift, screenX, screenY, mapX, mapY, handle) {
            //台风路径点泡泡信息
            var objLayerPoint1 = thisObj.tf.Layer_point.hitTest(screenX, screenY);
            if (!!objLayerPoint1) {
                var element1 = objLayerPoint1.element;
                if (element1._tfbh == undefined) { return; }
                ;
                // if (thisObj.options.interfaceMsg.trackPoint.enable == 1) {
                //     thisObj.$bus.$emit(thisObj.options.interfaceMsg.trackPoint.name, element1); //触发点击轨迹点事件
                // }
                thisObj._showRoutePointPopup(element1);
            }
        };
        this.map.listen('click', this._getMapClickListener_ts, this);
        
        var selfObj = this;
        
        this._getMapMouseMoveListener_ts = function (button, shift, screenX, screenY, mapX, mapY, handle) {
            
            selfObj.options.toolTipWare.clear();
            selfObj.tf.selectPoint.clear();
            var objLayerPoint = selfObj.tf.Layer_point.hitTest(screenX, screenY);
            if (!!objLayerPoint) {
                var element = objLayerPoint.element;
                
                selfObj._createFocusPoint(element);
                if (selfObj.options.popup.display == 1) {
                    //显示弹出信息框
                    selfObj._showPopup(element, selfObj.tf.Layer_point);
                }
            }
            //预测台风路径点泡泡信息
            var objForecastPoint = thisObj.tf.Layer_forecast.hitTest(screenX, screenY);
            if (!!objForecastPoint) {
                var eleForecast = objForecastPoint.element;
                if (!eleForecast || eleForecast._forecast == undefined) { return; }
                ;
                // if (selfObj.options.interfaceMsg.forecastPoint.enable == 1) {
                //     thisObj.$bus.$emit(thisObj.options.interfaceMsg.forecastPoint.name, eleForecast); //触发点击轨迹点事件
                // }
                
                if (selfObj.options.popupForecast.display == 1) {
                    //显示弹出信息框
                    selfObj._showPopupForecast(eleForecast, uuid);
                }
            }
        };
        this.map.listen('mousemove', this._getMapMouseMoveListener_ts, this);
    },
    /**
     * 查询风圈
     * @param tfbh
     * @param grades
     * @returns {Promise.<{grade7: {}, grade10: {}, grade12: {}}>}
     */
    getTyphoonCircleGeom: async function (tfbh, grades) {
        const self = this;
        let g = {'grade7': {}, 'grade10': {}, 'grade12': {}};
        if (grades && grades.length > 0) {
            g = {};
            if (grades.indexOf(7) > -1) {
                g.grade7 = true;
            }
            if (grades.indexOf(10) > -1) {
                g.grade10 = true;
            }
            if (grades.indexOf(12) > -1) {
                g.grade12 = true;
            }
        }
        var data = await this.service.getTyphoonInfo({typhoonid: tfbh});
        var resultData = data;
        var oneData = resultData[0];
        var features = oneData.features;
        const grade7GeomList = [];
        const grade10GeomList = [];
        const grade12GeomList = [];
        features.forEach((feature) => {
            if (feature && feature.properties && feature.geometry) {
                const ele = {_data: feature};
                var result = self._getCircle(ele);
                result = self._typhoonCircle2Ring(result, "ne");
                result = self._typhoonCircle2Ring(result, "nw");
                result = self._typhoonCircle2Ring(result, "se");
                result = self._typhoonCircle2Ring(result, "sw");
                if (g.grade7 && result.grade_7) {
                    result = this._getUnionedGeom(result, "grade_7");
                    result.grade_7.geom && grade7GeomList.push(result.grade_7.geom);
                }
                if (g.grade10 && result.grade_10) {
                    result = this._getUnionedGeom(result, "grade_10");
                    result.grade_10.geom && grade10GeomList.push(result.grade_10.geom);
                }
                if (g.grade12 && result.grade_12) {
                    result = this._getUnionedGeom(result, "grade_12");
                    result.grade_12.geom && grade12GeomList.push(result.grade_12.geom);
                }
            }
        });
        // var symbol1 = new g2.sfs.SimpleFillSymbol({
        //     borderThickness: 1,
        //     fillColor: new g2.sfs.Color({r: 255, g: 228, b: 181, a: 90}),
        //     borderColor: new g2.sfs.Color({r: 255, g: 100, b: 100, a: 190})
        // });
        // var symbol2 = new g2.sfs.SimpleFillSymbol({
        //     borderThickness: 1,
        //     fillColor: new g2.sfs.Color({r: 171, g: 130, b: 255, a: 150}),
        //     borderColor: new g2.sfs.Color({r: 255, g: 100, b: 100, a: 190})
        // });
        // var symbol3 = new g2.sfs.SimpleFillSymbol({
        //     borderThickness: 1,
        //     fillColor: new g2.sfs.Color({r: 135, g: 206, b: 250, a: 200}),
        //     borderColor: new g2.sfs.Color({r: 255, g: 100, b: 100, a: 190})
        // });
        if (g.grade7) {
            const grade7UnionGeom = this._getUnionedGeometry(grade7GeomList);
            const simplyfiedGeom = this._simplifyGeom(grade7UnionGeom);
            const geometry = this._getG2GeometryFromGeojson(simplyfiedGeom);
            const geometry_ = this._removeHolesGeom(geometry);
            g.grade7 = geometry_;
            // const element1 = new g2.sfs.Element({
            //     geometry: g.grade7, symbol: symbol1
            // });
            // this.tf.typhoonIconLayer.add(element1);
        }
        if (g.grade10) {
            const grade10UnionGeom = this._getUnionedGeometry(grade10GeomList);
            const simplyfiedGeom = this._simplifyGeom(grade10UnionGeom);
            const geometry = this._getG2GeometryFromGeojson(simplyfiedGeom);
            const geometry_ = this._removeHolesGeom(geometry);
            g.grade10 = geometry_;
            // const element2 = new g2.sfs.Element({
            //     geometry: g.grade10, symbol: symbol2
            // });
            // this.tf.typhoonIconLayer.add(element2);
        }
        if (g.grade12) {
            const grade12UnionGeom = this._getUnionedGeometry(grade12GeomList);
            const simplyfiedGeom = this._simplifyGeom(grade12UnionGeom);
            const geometry = this._getG2GeometryFromGeojson(simplyfiedGeom);
            const geometry_ = this._removeHolesGeom(geometry);
            g.grade12 = geometry_;
            // const element3 = new g2.sfs.Element({
            //     geometry: geometry_, symbol: symbol3
            // });
            // this.tf.typhoonIconLayer.add(element3);
        }
        return g;
    },
    /**
     * 抽稀
     * @private
     */
    _simplifyGeom: function (geojson) {
        // 平滑
        var smoothed = this._smoothGeom(geojson);
        var options = {tolerance: 0.01, highQuality: true};
        // 抽稀
        var simplified = turf.simplify(smoothed, options);
        
        return simplified;
    },
    _smoothGeom: function (geom) {
        let polygon = null;
        if (geom.type === 'Polygon') {
            polygon = turf.polygon(geom.coordinates);
        } else if (geom.type === 'MultiPolygon') {
            polygon = turf.multiPolygon(geom.coordinates);
        }
        var polyline = turf.polygonToLine(polygon);
        var result = null;
        if (polyline.type && polyline.type === 'FeatureCollection' && polyline.features) {
            var multiLineString = [];
            polyline.features.forEach((feature) => {
                if (feature.geometry.type === 'LineString') {
                    var line = turf.lineString(feature.geometry.coordinates);
                    var curved = turf.bezierSpline(line);
                    multiLineString.push(curved.geometry.coordinates);
                } else if (feature.geometry.type === 'MultiLineString') {
                    for (let i = 0; i < feature.geometry.coordinates.length; i++) {
                        var line = turf.lineString(feature.geometry.coordinates[i]);
                        var curved = turf.bezierSpline(line);
                        multiLineString.push(curved.geometry.coordinates);
                    }
                }
            });
            var multiPolyline = turf.multiLineString(multiLineString);
            result = turf.lineToPolygon(multiPolyline);
        } else if (polyline.geometry.type === 'MultiLineString') {
            var multiLineString = [];
            for (let i = 0; i < polyline.geometry.coordinates.length; i++) {
                var line = turf.lineString(polyline.geometry.coordinates[i]);
                var curved = turf.bezierSpline(line);
                // var curvedPoly = turf.lineToPolygon(curved);
                multiLineString.push(curved.geometry.coordinates);
            }
            var multiPolyline = turf.multiLineString(multiLineString);
            result = turf.lineToPolygon(multiPolyline);
        } else if (polyline.geometry.type === 'LineString') {
            var line = turf.lineString(polyline.geometry.coordinates);
            var curved = turf.bezierSpline(line);
            result = turf.lineToPolygon(curved);
        }
        return result.geometry;
    },
    /**
     * 移除polygon中的holes
     * @param geom
     * @returns {*}
     * @private
     */
    _removeHolesGeom: function (geom) {
        var projectService = new g2.sfs.CoordinateTransform();
        var measureService = new g2.sfs.MeasureService({projectService: projectService});
        const type = geom.getGeometryType();
        if (type === 14) {
            if (geom.holes.length > 0) {
                for (let i = geom.holes.length - 1; i >= 0; i--) {
                    const coords = geom.holes[i].asGeoJson().coordinates[0];
                    // {"type": "FeatureCollection", "features": [geom.holes[i].asGeoJson()]}
                    const line = turf.lineString(coords);
                    const polygon = turf.lineToPolygon(line);
                    const geometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
                        polygon.geometry,
                        this.options.dataSpatialReference
                    );
                    const area = measureService.area(geometry) / 1000000;
                    if (area && area < 5000) {
                        geom.holes.splice(i, 1);
                    }
                }
            }
            
        } else if (type === 16) {
            for (let i = 0; i < geom.geometries.length; i++) {
                const geometry = this._removeHolesGeom(geom.geometries[i]);
                geom.geometries[i] = geometry;
            }
        }
        return geom;
    },
    _getG2GeometryFromGeojson: function (geom) {
        const gemoetry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
            geom,
            this.options.dataSpatialReference
        );
        return gemoetry;
    },
    /**
     * 将列表内geom全部合并
     * @param list
     * @returns {*}
     * @private
     */
    _getUnionedGeometry: function (list) {
        var reader = new jsts.io.GeoJSONReader();
        let geometry = null;
        for (let i = 0; i < list.length; i++) {
            if (i === 0) {
                geometry = reader.read(list[i]);
            } else {
                geometry = geometry.union(reader.read(list[i]));
            }
        }
        var GeoJSONWriter = new jsts.io.GeoJSONWriter();
        let result = null;
        if (geometry) {
            result = GeoJSONWriter.write(geometry);
        }
        return result;
    },
    /**
     * 查询url显示台风
     */
    _getTyphoonCircleTan: function (tfbh, visibleFlag, fit) {
        return new Promise((resolve, reject) => {
            var thisObj = this;
            var returnObj = {'status': -1, "data": ''};
            
            this.service.getTyphoonInfo({typhoonid: tfbh}).then(function (data) {
                var resultData = data;
                if (!!resultData) {
                    returnObj.status = 1;
                    returnObj.data = resultData[0]
                    if (resultData[0] == undefined) { return }
                    thisObj._calculateTyphoonCircleTan(resultData[0], visibleFlag, fit);
                    
                } else {
                    returnObj.status = -1;
                    returnObj.data = 'no data ! Please check data.....';
                }
                resolve();
            });
        })
        
    },
    _calculateTyphoonCircleTan: function (data, visibleFlag, fit) {
        const startTime = new Date(data.begin_time.replace("T", " "));
        
        
        // for (let i = 0; i < data.features.length; i++) {
        const feature = data.features[i];
        
        // }
    },
    _calRadius: function (point, radius) {
        let pi = Math.PI / 180.0;
        let p2x = point.x - 2 / pi * Math.asin((Math.sin(radius / 2 / 6378.137 / 1000) / Math.cos(pi * point.y)));
        return Math.abs(p2x - point.x);
    },
    _getForecastCircleTan: async function (ele, type) {
        const self = this;
        type = type? type : '中国';
        const path = this.tf.forecastLines[ele._tfbh][type];
        const pathGeojson = path.geometry.asGeoJson().coordinates[0];
        const pathLine = turf.lineString(pathGeojson);
        const symbol = new g2.sfs.SimpleFillSymbol({
            borderThickness: 0,
            fillColor: new g2.sfs.Color({r: 171, g: 130, b: 255, a: 150}),
            borderColor: new g2.sfs.Color({r: 255, g: 100, b: 100, a: 190})
        });
        var symbol3 = new g2.sfs.SimpleFillSymbol({
            borderThickness: 2,
            style: this.options.forecast.polyStyle.style,
            fillColor: new g2.sfs.Color({r: 250, g: 224, b: 2, a: 56}),
            borderColor: new g2.sfs.Color({r: 255, g: 192, b: 11, a: 255})
        });
        const markerSymbol = new g2.sfs.SimpleMarkerSymbol({
            fillColor: new g2.sfs.Color({r: 171, g: 130, b: 255, a: 200}),
            borderColor: new g2.sfs.Color({r: 255, g: 100, b: 100, a: 250}),
            size: 5
        });
        
        // extent = [envelope.minx, envelope.miny, envelope.maxx, envelope.maxy];
        let extent = await this.getExtentById(ele._tfbh);
        extent[0] = extent[0] - 5;
        extent[1] = extent[1] - 5;
        extent[2] = extent[2] + 5;
        extent[3] = extent[3] + 5;
        
        const startPoint = [parseFloat(ele.geometry.x), parseFloat(ele.geometry.y)];
        const prop = ele._data.properties;
        const realTime = new Date(prop.time.replace("T", " "));
        let forecast = null;
        prop.forecast.forEach((f) => {
            if (f.region === '中国') {
                forecast = f;
            }
        });
        let pointListLength = 0;
      
        let circlePoly = null;
        let circleList = [];
        forecast.features.forEach((feature, index) => {
            const time = new Date(feature.properties.time.replace("T", " "));
            const timeDiff = (time - realTime) / (1000 * 60 * 60);
            let radius = self._calRadiusByTimeDiff(timeDiff);
            const center = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
                feature.geometry,
                this.options.dataSpatialReference
            );
            radius = self._calRadius(center, radius * 1000);
            const circle = new g2.sfs.Circle({
                radius,
                center,
                spatialReference: this.options.dataSpatialReference,
            });

            let insideFlag = turf.booleanPointInPolygon(startPoint, circle.asGeoJson());
            if (!insideFlag) {
                circleList.push(circle);
                pointListLength++
                // const circleEle = new g2.sfs.Element({
                //     geometry: circle, symbol
                // });
                // self.tf.typhoonIconLayer.add(circleEle);
            }
            
        });
        let pointList = new Array(pointListLength * 2 + 1);
        // 循环预测点 创建圆
        circleList.forEach((circle, index) => {
            const circleGeojson = circle.asGeoJson().coordinates;
            circlePoly = circle.asGeoJson();
            const polygon = turf.polygon(circleGeojson);
            let point = null;
            let point1, point2;// 第一个圆算出的两个切点
            if (index === 0) {// 第一个圆，计算圆和实际点的正切（两个）
                const pointArray = startPoint;
                pointList[0] = pointArray;
                point = turf.point(pointArray);
                var tangents = turf.polygonTangents(point, polygon);
                tangents.features.forEach((feature, i) => {
                    const pos = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
                        feature.geometry,
                        self.options.dataSpatialReference
                    );
                    // const element = new g2.sfs.Element({
                    //     geometry: pos, symbol: markerSymbol
                    // });
                    // self.tf.typhoonIconLayer.add(element);
                    if (i == 0) {
                        point1 = [pos.x, pos.y];
                        pointList[1] = point1;
                    } else {
                        point2 = [pos.x, pos.y];
                        pointList[pointList.length - 1] = point2;
                    }
                });
            } else {// 之后每一个圆 计算和前面一个圆的2两个正切点 各自的正切点
                // TODO 待改，先按简单算法走通流程
                //=================================================================
               /* let lastcircle = circleList[index - 1]; // 前一个圆
                // circle 当前的圆
                let tanCoords = this._calcTangent({x: lastcircle.center.x, y: lastcircle.center.y}, {
                    x: circle.center.x,
                    y: circle.center.y
                }, lastcircle.radius, circle.radius);
                console.log(tanCoords);
                
                // 上一个圆对应的两个切点
                if (index !== 1) {
                    point1 = pointList[index];
                    point2 = pointList[pointList.length - index];
                }
                var from1 = turf.point(point1);// 下面的切点
                var from2 = turf.point(point2);// 上面的切点
                var to1 = turf.point(tanCoords[0]);
                var to2 = turf.point(tanCoords[1]);
                var to3 = turf.point(tanCoords[2]);
                var to4 = turf.point(tanCoords[3]);
                var options = {units: 'degrees'};
                
                var distance11 = turf.distance(from1, to1, options); //下面切点与大圆切点的距离
                var distance12 = turf.distance(from1, to2, options);//下面切点与大圆切点的距离
                var distance21 = turf.distance(from2, to3, options);//上面切点与小圆切点的距离
                var distance22 = turf.distance(from2, to4, options);//上面切点与小圆切点的距离
                let point_up_s, point_down_s, point_down_l, point_up_l;
                if (distance11 > distance12) {
                    point_down_l = tanCoords[1];//下面与大圆的切点
                } else {
                    point_up_l = tanCoords[0];//上面与大圆的切点
                }
                if (distance21 > distance22) {
                    point_up_s = tanCoords[3];//上面与小圆的切点
                } else {
                    point_down_s = tanCoords[2];//下面与小圆的切点
                }
                
                let seg_down = [point_down_s, point_down_l];
                let seg_up = [point_up_s, point_up_l];
                
                let last_seg_down, last_seg_up;
                if (index === 1) {
                    last_seg_down = [[startPoint.x, startPoint.y], point1];
                    last_seg_up = [[startPoint.x, startPoint.y], point2];
                } else {
                    last_seg_down = [[startPoint.x, startPoint.y], point1];
                    last_seg_up = [[startPoint.x, startPoint.y], point2];
                }
    
                this._segmentsIntr({x:point_down_s[0],y:point_down_s[1]}, {x: point_down_l[0], y: point_down_l[1]})*/
                //================================================================
                point = pointList[index];
                var tangents = turf.polygonTangents(point, polygon);
                tangents.features.forEach((feature, i) => {
                    var line1 = turf.lineString([point, feature.geometry.coordinates]);
                    var intersects = turf.lineIntersect(line1, pathLine);
                    if (intersects && intersects.features && intersects.features.length > 0) {
                        //
                    } else {
                        const pos = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
                            feature.geometry,
                            self.options.dataSpatialReference
                        );
                        // const element = new g2.sfs.Element({
                        //     geometry: pos, symbol: markerSymbol
                        // });
                        // self.tf.typhoonIconLayer.add(element);
                        pointList[index + 1] = feature.geometry.coordinates;
                    }
                });
                let point2 = pointList[pointList.length - index];
                var tangents = turf.polygonTangents(point2, polygon);
                tangents.features.forEach((feature, i) => {
                    var line1 = turf.lineString([point2, feature.geometry.coordinates]);
                    var intersects = turf.lineIntersect(line1, pathLine);
                    if (intersects && intersects.features && intersects.features.length > 0) {
                        //
                    } else {
                        const pos = g2.sfs.GeometryFactory.createGeometryFromGeoJson(
                            feature.geometry,
                            self.options.dataSpatialReference
                        );
                        // const element = new g2.sfs.Element({
                        //     geometry: pos, symbol: markerSymbol
                        // });
                        // self.tf.typhoonIconLayer.add(element);
                        pointList[pointList.length - index - 1] = feature.geometry.coordinates;
                    }
                });
                
                //====================================================================
                
                // 如果是最后一个圆，需要取后半截弧，加到pointList里面
                if (index === forecast.features.length - 1) {
                    circlePoly = circle.asGeoJson();
                }
                
            }
            
        });
        
        // var arr = [];
        // console.log(pointList);
        // pointList.map(function (val, n) {
        //     //过滤规则为，不为空串、不为null、不为undefined，也可自行修改
        //     if (val !== "" && val != undefined) {
        //         arr.push(val);
        //     }
        // });
        // console.log(pointList);
        var lineString = turf.lineString(pointList);
        var curved = turf.bezierSpline(lineString);
        var polygon = turf.lineToPolygon(lineString);
        
        const union = this._getUnionedGeometry([polygon.geometry, circlePoly]);
        
        const geometry = this._getG2GeometryFromGeojson(union);
        const tanEle = new g2.sfs.Element({
            geometry, symbol: symbol3
        });
        this.tf.Layer_forecast[ele._tfbh].add(tanEle);
    },
    _calcTangent: function (c1, c2, r1, r2) {
        // 圆心之间的距离
        const d = Math.sqrt(Math.pow(c1.x - c2.x, 2) + Math.pow(c1.y - c2.y, 2));
        // 外公切线与连心线夹角的角度
        const theta = Math.acos((r1 - r2) / d);
        const vc1c2 = {x: c2.x - c1.x, y: c2.y - c1.y}; // 屏幕坐标系与笛卡尔坐标系是y轴是反着的
        let radC1C2 = Math.acos(vc1c2.x / Math.sqrt(Math.pow(vc1c2.x, 2) + Math.pow(vc1c2.y, 2)));
        if (c2.y <= c1.y) {
            // 大圆上的切点
            const p1 = {x: c1.x + Math.cos(theta + radC1C2) * r1, y: c1.y - Math.sin(theta + radC1C2) * r1};
            const p2 = {x: c1.x + Math.cos(theta - radC1C2) * r1, y: c1.y + Math.sin(theta - radC1C2) * r1};
            // 小圆上的切点
            const p3 = {x: c2.x + Math.cos(theta + radC1C2) * r2, y: c2.y - Math.sin(theta + radC1C2) * r2};
            const p4 = {x: c2.x + Math.cos(theta - radC1C2) * r2, y: c2.y + Math.sin(theta - radC1C2) * r2};
            return [p1, p2, p3, p4];
        } else {
            radC1C2 = Math.PI - radC1C2;
            // 大圆上的切点
            const p1 = {
                x: c1.x + Math.cos(Math.PI - theta - radC1C2) * r1,
                y: c1.y + Math.sin(Math.PI - theta - radC1C2) * r1
            };
            const p2 = {
                x: c1.x + Math.cos(Math.PI - (theta - radC1C2)) * r1,
                y: c1.y - Math.sin(Math.PI - (theta - radC1C2)) * r1
            };
            // 小圆上的切点
            const p3 = {
                x: c2.x + Math.cos(Math.PI - theta - radC1C2) * r2,
                y: c2.y + Math.sin(Math.PI - theta - radC1C2) * r2
            };
            const p4 = {
                x: c2.x + Math.cos(Math.PI - (theta - radC1C2)) * r2,
                y: c2.y - Math.sin(Math.PI - (theta - radC1C2)) * r2
            };
            return [p1, p2, p3, p4];
        }
    },
    _calRadiusByTimeDiff: function (timeDiff) {
        let radius = null;
        if (timeDiff > 0 && timeDiff <= 12) {
            radius = 100;
        }
        else if (timeDiff > 12 && timeDiff <= 24) {
            radius = 150;
        }
        else if (timeDiff > 24 && timeDiff <= 36) {
            radius = 165;
        }
        else if (timeDiff > 36 && timeDiff <= 48) {
            radius = 180;
        }
        else if (timeDiff > 48 && timeDiff <= 60) {
            radius = 195;
        }
        else if (timeDiff > 60 && timeDiff <= 72) {
            radius = 210;
        }
        else if (timeDiff > 72 && timeDiff <= 84) {
            radius = 225;
        }
        else if (timeDiff > 84 && timeDiff <= 96) {
            radius = 240;
        }
        else if (timeDiff > 96) {
            radius = 270;
        }
        return radius;
    },
    _segmentsIntr: function (a, b, c, d) {
        
        //线段ab的法线N1
        var nx1 = (b.y - a.y), ny1 = (a.x - b.x);
        
        //线段cd的法线N2
        var nx2 = (d.y - c.y), ny2 = (c.x - d.x);
        
        //两条法线做叉乘, 如果结果为0, 说明线段ab和线段cd平行或共线,不相交
        var denominator = nx1 * ny2 - ny1 * nx2;
        if (denominator == 0) {
            return false;
        }
        
        //在法线N2上的投影
        var distC_N2 = nx2 * c.x + ny2 * c.y;
        var distA_N2 = nx2 * a.x + ny2 * a.y - distC_N2;
        var distB_N2 = nx2 * b.x + ny2 * b.y - distC_N2;
        
        // 点a投影和点b投影在点c投影同侧 (对点在线段上的情况,本例当作不相交处理);
        if (distA_N2 * distB_N2 >= 0) {
            return false;
        }
        
        //
        //判断点c点d 和线段ab的关系, 原理同上
        //
        //在法线N1上的投影
        var distA_N1 = nx1 * a.x + ny1 * a.y;
        var distC_N1 = nx1 * c.x + ny1 * c.y - distA_N1;
        var distD_N1 = nx1 * d.x + ny1 * d.y - distA_N1;
        if (distC_N1 * distD_N1 >= 0) {
            return false;
        }
        
        //计算交点坐标
        var fraction = distA_N2 / denominator;
        var dx = fraction * ny1,
            dy = -fraction * nx1;
        return {x: a.x + dx, y: a.y + dy};
    }
    
});
module.exports = component;
